//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.4.0.0 (NJsonSchema v11.3.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class ClientBase {

  authToken = '';
  protected constructor() {
  }

  setAuthToken(token: string) {
    this.authToken = token;
  }

  protected transformOptions(options: any): Promise<any> {
    options.headers["authorization"] = `Bearer ${this.authToken}`;
    return Promise.resolve(options);
  }
}

export class AccomplishmentClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    get(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Accomplishment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get2(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/Accomplishment";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet2(_response);
        });
    }

    protected processGet2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get3(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/launch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet3(_response);
        });
    }

    protected processGet3(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    get4(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/launch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGet4(_response);
        });
    }

    protected processGet4(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishment(personId: number, accomplishmentName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Accomplishment/{personId}/{accomplishmentName}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishment(_response);
        });
    }

    protected processAddAccomplishment(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishment2(personId: number, accomplishmentName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/Accomplishment/{personId}/{accomplishmentName}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishment2(_response);
        });
    }

    protected processAddAccomplishment2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishment3(personId: number, accomplishmentName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/launch/{personId}/{accomplishmentName}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishment3(_response);
        });
    }

    protected processAddAccomplishment3(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishment4(personId: number, accomplishmentName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/launch/{personId}/{accomplishmentName}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishment4(_response);
        });
    }

    protected processAddAccomplishment4(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishmentByPortal(personId: number, accomplishmentName: string, portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Accomplishment/{personId}/{accomplishmentName}/{portalId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishmentByPortal(_response);
        });
    }

    protected processAddAccomplishmentByPortal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishmentByPortal2(personId: number, accomplishmentName: string, portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/Accomplishment/{personId}/{accomplishmentName}/{portalId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishmentByPortal2(_response);
        });
    }

    protected processAddAccomplishmentByPortal2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishmentByPortal3(personId: number, accomplishmentName: string, portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/launch/{personId}/{accomplishmentName}/{portalId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishmentByPortal3(_response);
        });
    }

    protected processAddAccomplishmentByPortal3(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    addAccomplishmentByPortal4(personId: number, accomplishmentName: string, portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/launch/{personId}/{accomplishmentName}/{portalId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        if (accomplishmentName === undefined || accomplishmentName === null)
            throw new Error("The parameter 'accomplishmentName' must be defined.");
        url_ = url_.replace("{accomplishmentName}", encodeURIComponent("" + accomplishmentName));
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAddAccomplishmentByPortal4(_response);
        });
    }

    protected processAddAccomplishmentByPortal4(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    starttour(siteCode: string, personId: number | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Accomplishment/starttour/{siteCode}/{personId}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStarttour(_response);
        });
    }

    protected processStarttour(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    starttour2(siteCode: string, personId: number | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/Accomplishment/starttour/{siteCode}/{personId}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStarttour2(_response);
        });
    }

    protected processStarttour2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    starttour3(siteCode: string, personId: number | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/launch/starttour/{siteCode}/{personId}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStarttour3(_response);
        });
    }

    protected processStarttour3(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    starttour4(siteCode: string, personId: number | null): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api2/launch/starttour/{siteCode}/{personId}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStarttour4(_response);
        });
    }

    protected processStarttour4(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AdminClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    
  public customMethodCopiedInFromTemplate() {

  }

    getClients(): Promise<ClientsVm> {
        let url_ = this.baseUrl + "/api/Admin/clients";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClients(_response);
        });
    }

    protected processGetClients(response: Response): Promise<ClientsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientsVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientsVm>(null as any);
    }

    getClient(clientId: number): Promise<ClientDTO> {
        let url_ = this.baseUrl + "/api/Admin/client/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetClient(_response);
        });
    }

    protected processGetClient(response: Response): Promise<ClientDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ClientDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ClientDTO>(null as any);
    }

    getPortalsByClient(clientId: number): Promise<PortalDTO[]> {
        let url_ = this.baseUrl + "/api/Admin/portalsByClient/{clientId}";
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortalsByClient(_response);
        });
    }

    protected processGetPortalsByClient(response: Response): Promise<PortalDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalDTO[]>(null as any);
    }

    savePortal(cmd: SavePortalCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Admin/portal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSavePortal(_response);
        });
    }

    protected processSavePortal(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deletePortal(portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/deleteportal/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePortal(_response);
        });
    }

    protected processDeletePortal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveClient(command: SaveClientCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Admin/saveclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveClient(_response);
        });
    }

    protected processSaveClient(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getRoleTypes(): Promise<RolesVm> {
        let url_ = this.baseUrl + "/api/Admin/roletypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoleTypes(_response);
        });
    }

    protected processGetRoleTypes(response: Response): Promise<RolesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RolesVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RolesVm>(null as any);
    }

    saveRoleType(command: SaveRoleTypeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Admin/saverole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveRoleType(_response);
        });
    }

    protected processSaveRoleType(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteRoleType(roleTypeId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/deleteRoleType/{roleTypeId}";
        if (roleTypeId === undefined || roleTypeId === null)
            throw new Error("The parameter 'roleTypeId' must be defined.");
        url_ = url_.replace("{roleTypeId}", encodeURIComponent("" + roleTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRoleType(_response);
        });
    }

    protected processDeleteRoleType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getVideo(videoId: number): Promise<GetVideoDTO> {
        let url_ = this.baseUrl + "/api/Admin/video/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVideo(_response);
        });
    }

    protected processGetVideo(response: Response): Promise<GetVideoDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetVideoDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetVideoDTO>(null as any);
    }

    getVideosList(): Promise<VideoListItemDTO[]> {
        let url_ = this.baseUrl + "/api/Admin/videos";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVideosList(_response);
        });
    }

    protected processGetVideosList(response: Response): Promise<VideoListItemDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VideoListItemDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VideoListItemDTO[]>(null as any);
    }

    saveVideo(command: SaveVideoRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Admin/savevideo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveVideo(_response);
        });
    }

    protected processSaveVideo(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteVideo(videoId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/deletevideo/{videoId}";
        if (videoId === undefined || videoId === null)
            throw new Error("The parameter 'videoId' must be defined.");
        url_ = url_.replace("{videoId}", encodeURIComponent("" + videoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteVideo(_response);
        });
    }

    protected processDeleteVideo(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setNewPassword(dto: SetNewPasswordDTO): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/setNewPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetNewPassword(_response);
        });
    }

    protected processSetNewPassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    clearCache(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/clearcache";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClearCache(_response);
        });
    }

    protected processClearCache(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLinkWarnings(): Promise<WarningLinkDTO[]> {
        let url_ = this.baseUrl + "/api/Admin/getlinkwarnings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinkWarnings(_response);
        });
    }

    protected processGetLinkWarnings(response: Response): Promise<WarningLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WarningLinkDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WarningLinkDTO[]>(null as any);
    }

    suppressWarningsByUrl(url: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/suppresswarningsbyurl?";
        if (url === null)
            throw new Error("The parameter 'url' cannot be null.");
        else if (url !== undefined)
            url_ += "url=" + encodeURIComponent("" + url) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSuppressWarningsByUrl(_response);
        });
    }

    protected processSuppressWarningsByUrl(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStaffNotifications(request: GetStaffNotificationsRequest): Promise<GetStaffNotificationsVm> {
        let url_ = this.baseUrl + "/api/Admin/staffnotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStaffNotifications(_response);
        });
    }

    protected processGetStaffNotifications(response: Response): Promise<GetStaffNotificationsVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GetStaffNotificationsVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStaffNotificationsVm>(null as any);
    }

    saveStaffNotification(request: SaveStaffNotificationRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/staffnotification/save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveStaffNotification(_response);
        });
    }

    protected processSaveStaffNotification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    resolveStaffNotifications(request: ResolveStaffNotificationsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/staffnotification/resolve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processResolveStaffNotifications(_response);
        });
    }

    protected processResolveStaffNotifications(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCounts(): Promise<CountsDTO> {
        let url_ = this.baseUrl + "/api/Admin/counts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCounts(_response);
        });
    }

    protected processGetCounts(response: Response): Promise<CountsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CountsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CountsDTO>(null as any);
    }

    getStaffNote(page: string): Promise<StaffNoteDTO> {
        let url_ = this.baseUrl + "/api/Admin/getstaffnote/{page}";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStaffNote(_response);
        });
    }

    protected processGetStaffNote(response: Response): Promise<StaffNoteDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StaffNoteDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaffNoteDTO>(null as any);
    }

    saveStaffNote(request: SaveStaffNoteRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/savestaffnote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveStaffNote(_response);
        });
    }

    protected processSaveStaffNote(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAdminNote(page: string, isForTenantAdmin: boolean | undefined, portalId: number | null | undefined): Promise<AdminNoteDTO> {
        let url_ = this.baseUrl + "/api/Admin/getadminnote/{page}?";
        if (page === undefined || page === null)
            throw new Error("The parameter 'page' must be defined.");
        url_ = url_.replace("{page}", encodeURIComponent("" + page));
        if (isForTenantAdmin === null)
            throw new Error("The parameter 'isForTenantAdmin' cannot be null.");
        else if (isForTenantAdmin !== undefined)
            url_ += "isForTenantAdmin=" + encodeURIComponent("" + isForTenantAdmin) + "&";
        if (portalId !== undefined && portalId !== null)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAdminNote(_response);
        });
    }

    protected processGetAdminNote(response: Response): Promise<AdminNoteDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminNoteDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminNoteDTO>(null as any);
    }

    saveAdminNote(request: SaveAdminNoteRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/saveadminnote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveAdminNote(_response);
        });
    }

    protected processSaveAdminNote(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    movePortalToClient(request: MovePortalToClientRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/moveportaltoclient";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processMovePortalToClient(_response);
        });
    }

    protected processMovePortalToClient(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bulkAddTraining(request: BulkAddTrainingRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/bulkaddtraining";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAddTraining(_response);
        });
    }

    protected processBulkAddTraining(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getStartupData(): Promise<AdminStartupData> {
        let url_ = this.baseUrl + "/api/Admin/getStartupData";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStartupData(_response);
        });
    }

    protected processGetStartupData(response: Response): Promise<AdminStartupData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AdminStartupData;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AdminStartupData>(null as any);
    }

    generatePasswordResetLink(username: string | undefined, siteCode: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Admin/generatePasswordResetLink?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (siteCode === null)
            throw new Error("The parameter 'siteCode' cannot be null.");
        else if (siteCode !== undefined)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGeneratePasswordResetLink(_response);
        });
    }

    protected processGeneratePasswordResetLink(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    pruneDB(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPruneDB(_response);
        });
    }

    protected processPruneDB(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getEmailTemplates(): Promise<Setting[]> {
        let url_ = this.baseUrl + "/api/Admin/getEmailTemplates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetEmailTemplates(_response);
        });
    }

    protected processGetEmailTemplates(response: Response): Promise<Setting[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Setting[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Setting[]>(null as any);
    }

    saveEmailTemplate(request: SaveEmailTemplate): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/saveEmailTemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveEmailTemplate(_response);
        });
    }

    protected processSaveEmailTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteEmailTemplate(settingsId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Admin/deleteEmailTemplate?";
        if (settingsId === null)
            throw new Error("The parameter 'settingsId' cannot be null.");
        else if (settingsId !== undefined)
            url_ += "settingsId=" + encodeURIComponent("" + settingsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteEmailTemplate(_response);
        });
    }

    protected processDeleteEmailTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AlertClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getAlertSubscriptions(portalId: number): Promise<AlertPersonDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/subscriptions/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertSubscriptions(_response);
        });
    }

    protected processGetAlertSubscriptions(response: Response): Promise<AlertPersonDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertPersonDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertPersonDTO[]>(null as any);
    }

    unsubscribe(email: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/alert/unsubscribe?";
        if (email === null)
            throw new Error("The parameter 'email' cannot be null.");
        else if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUnsubscribe(_response);
        });
    }

    protected processUnsubscribe(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAlertTemplates(portalId: number): Promise<TemplateDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/templates/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertTemplates(_response);
        });
    }

    protected processGetAlertTemplates(response: Response): Promise<TemplateDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TemplateDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TemplateDTO[]>(null as any);
    }

    getAlertHistory(portalId: number | undefined, maxResults: number | undefined): Promise<AlertHistoryDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/history?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertHistory(_response);
        });
    }

    protected processGetAlertHistory(response: Response): Promise<AlertHistoryDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertHistoryDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertHistoryDTO[]>(null as any);
    }

    getAlertHistoryAll(maxResults: number | undefined, startDate: Date | null | undefined, endDate: Date | null | undefined): Promise<AlertHistoryAllDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/history/all?";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertHistoryAll(_response);
        });
    }

    protected processGetAlertHistoryAll(response: Response): Promise<AlertHistoryAllDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertHistoryAllDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertHistoryAllDTO[]>(null as any);
    }

    getAlertHistoryDetail(alertHistoryId: number | undefined): Promise<AlertHistoryDTO2> {
        let url_ = this.baseUrl + "/api/Alert/alert/history/details?";
        if (alertHistoryId === null)
            throw new Error("The parameter 'alertHistoryId' cannot be null.");
        else if (alertHistoryId !== undefined)
            url_ += "alertHistoryId=" + encodeURIComponent("" + alertHistoryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertHistoryDetail(_response);
        });
    }

    protected processGetAlertHistoryDetail(response: Response): Promise<AlertHistoryDTO2> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertHistoryDTO2;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertHistoryDTO2>(null as any);
    }

    getAlertHistoryByEvent(maxResults: number | undefined): Promise<AlertHistoryEventDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/history/eventdetails?";
        if (maxResults === null)
            throw new Error("The parameter 'maxResults' cannot be null.");
        else if (maxResults !== undefined)
            url_ += "maxResults=" + encodeURIComponent("" + maxResults) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertHistoryByEvent(_response);
        });
    }

    protected processGetAlertHistoryByEvent(response: Response): Promise<AlertHistoryEventDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertHistoryEventDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertHistoryEventDTO[]>(null as any);
    }

    getFilteredAlertRecipientsCount(request: FilteredAlertRecipientsCountRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Alert/alert/filteredCount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilteredAlertRecipientsCount(_response);
        });
    }

    protected processGetFilteredAlertRecipientsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getFilteredAlertRecipients(request: FilteredAlertRecipientsRequest): Promise<AlertFilterDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/alert/filteredRecipients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFilteredAlertRecipients(_response);
        });
    }

    protected processGetFilteredAlertRecipients(response: Response): Promise<AlertFilterDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertFilterDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertFilterDTO[]>(null as any);
    }

    saveTemplate(request: SaveTemplateRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Alert/savetemplate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTemplate(_response);
        });
    }

    protected processSaveTemplate(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    sendAlert2(request: SendAlertRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Alert/alert/sendAlert2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAlert2(_response);
        });
    }

    protected processSendAlert2(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    sendAlertDirect2(request: SendAlertRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Alert/alert/sendAlertAsync2";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendAlertDirect2(_response);
        });
    }

    protected processSendAlertDirect2(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTemplate(templateId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/deletetemplate?";
        if (templateId === null)
            throw new Error("The parameter 'templateId' cannot be null.");
        else if (templateId !== undefined)
            url_ += "templateId=" + encodeURIComponent("" + templateId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTemplate(_response);
        });
    }

    protected processDeleteTemplate(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getCounts(): Promise<AlertCounts> {
        let url_ = this.baseUrl + "/api/Alert/counts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetCounts(_response);
        });
    }

    protected processGetCounts(response: Response): Promise<AlertCounts> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AlertCounts;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertCounts>(null as any);
    }

    alertStatusCallbackGET(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/AlertStatusCallback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlertStatusCallbackGET(_response);
        });
    }

    protected processAlertStatusCallbackGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    alertStatusCallbackPOST(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/AlertStatusCallback";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processAlertStatusCallbackPOST(_response);
        });
    }

    protected processAlertStatusCallbackPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAlertSMSLogs(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/getalertsmslogs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertSMSLogs(_response);
        });
    }

    protected processGetAlertSMSLogs(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getAlertOptOuts(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/getoptouts";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAlertOptOuts(_response);
        });
    }

    protected processGetAlertOptOuts(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    optIn(number: string | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Alert/optin?";
        if (number === null)
            throw new Error("The parameter 'number' cannot be null.");
        else if (number !== undefined)
            url_ += "number=" + encodeURIComponent("" + number) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processOptIn(_response);
        });
    }

    protected processOptIn(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateNotificationToken(userAgent: string | undefined, token: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/updateNotificationToken?";
        if (userAgent === null)
            throw new Error("The parameter 'userAgent' cannot be null.");
        else if (userAgent !== undefined)
            url_ += "userAgent=" + encodeURIComponent("" + userAgent) + "&";
        if (token !== undefined && token !== null)
            url_ += "token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpdateNotificationToken(_response);
        });
    }

    protected processUpdateNotificationToken(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setPushOptOut(isOptedOut: boolean | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/setPushOptOut?";
        if (isOptedOut === null)
            throw new Error("The parameter 'isOptedOut' cannot be null.");
        else if (isOptedOut !== undefined)
            url_ += "isOptedOut=" + encodeURIComponent("" + isOptedOut) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPushOptOut(_response);
        });
    }

    protected processSetPushOptOut(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPushSubscriptions(personId: number): Promise<PushSubscriptionDTO[]> {
        let url_ = this.baseUrl + "/api/Alert/pushsubscriptions/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPushSubscriptions(_response);
        });
    }

    protected processGetPushSubscriptions(response: Response): Promise<PushSubscriptionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PushSubscriptionDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PushSubscriptionDTO[]>(null as any);
    }

    deletePushSubscription(pushSubscriptionId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Alert/deletepushsubscription/{pushSubscriptionId}";
        if (pushSubscriptionId === undefined || pushSubscriptionId === null)
            throw new Error("The parameter 'pushSubscriptionId' must be defined.");
        url_ = url_.replace("{pushSubscriptionId}", encodeURIComponent("" + pushSubscriptionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePushSubscription(_response);
        });
    }

    protected processDeletePushSubscription(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    sendTestPushNotification(request: PushTestRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/Alert/sendtestpushnotification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSendTestPushNotification(_response);
        });
    }

    protected processSendTestPushNotification(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class AzureadClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    index(siteCode: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/azuread/{siteCode}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class CertificateClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    index(userName: string | null | undefined, propertyName: string | null | undefined, trainingProgramName: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/certificate/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName !== null && userName !== undefined)
            content_.append("userName", userName.toString());
        if (propertyName !== null && propertyName !== undefined)
            content_.append("propertyName", propertyName.toString());
        if (trainingProgramName !== null && trainingProgramName !== undefined)
            content_.append("trainingProgramName", trainingProgramName.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processIndex(_response);
        });
    }

    protected processIndex(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class HealthClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getStatus(): Promise<string> {
        let url_ = this.baseUrl + "/api/Health";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sentTestMessage(): Promise<string> {
        let url_ = this.baseUrl + "/api/Health/sendtest";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSentTestMessage(_response);
        });
    }

    protected processSentTestMessage(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    sentTestMessageTelnyx(): Promise<string> {
        let url_ = this.baseUrl + "/api/Health/sendtest2";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSentTestMessageTelnyx(_response);
        });
    }

    protected processSentTestMessageTelnyx(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LinkClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLinks(portalId: number): Promise<LinkSectionDTO[]> {
        let url_ = this.baseUrl + "/api/Link/links/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLinks(_response);
        });
    }

    protected processGetLinks(response: Response): Promise<LinkSectionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LinkSectionDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LinkSectionDTO[]>(null as any);
    }

    searchLinks(search: string): Promise<SearchLinkDTO[]> {
        let url_ = this.baseUrl + "/api/Link/searchlinks/{search}";
        if (search === undefined || search === null)
            throw new Error("The parameter 'search' must be defined.");
        url_ = url_.replace("{search}", encodeURIComponent("" + search));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchLinks(_response);
        });
    }

    protected processSearchLinks(response: Response): Promise<SearchLinkDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchLinkDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchLinkDTO[]>(null as any);
    }

    saveLink(command: SaveLink): Promise<number> {
        let url_ = this.baseUrl + "/api/Link/savelink";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveLink(_response);
        });
    }

    protected processSaveLink(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveLinkSection(command: SaveLinkSection): Promise<number> {
        let url_ = this.baseUrl + "/api/Link/savelinksection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveLinkSection(_response);
        });
    }

    protected processSaveLinkSection(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteLink(linkId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Link/deletelink/{linkId}";
        if (linkId === undefined || linkId === null)
            throw new Error("The parameter 'linkId' must be defined.");
        url_ = url_.replace("{linkId}", encodeURIComponent("" + linkId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLink(_response);
        });
    }

    protected processDeleteLink(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteLinkSection(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Link/deletesection/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteLinkSection(_response);
        });
    }

    protected processDeleteLinkSection(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveLinkOrder(command: SaveLinkSectionOrderRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Link/savelinkorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveLinkOrder(_response);
        });
    }

    protected processSaveLinkOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    importLinksFromPortal(command: ImportLinksFromPortalRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Link/importfromportal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportLinksFromPortal(_response);
        });
    }

    protected processImportLinksFromPortal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class MetricsClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPortalMetrics(): Promise<PortalMetricsVM> {
        let url_ = this.baseUrl + "/api/Metrics/portal";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortalMetrics(_response);
        });
    }

    protected processGetPortalMetrics(response: Response): Promise<PortalMetricsVM> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalMetricsVM;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalMetricsVM>(null as any);
    }

    getTopPortals(days: number | null | undefined, top: number | undefined): Promise<TopPortalsVM> {
        let url_ = this.baseUrl + "/api/Metrics/topPortals?";
        if (days !== undefined && days !== null)
            url_ += "days=" + encodeURIComponent("" + days) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTopPortals(_response);
        });
    }

    protected processGetTopPortals(response: Response): Promise<TopPortalsVM> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TopPortalsVM;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TopPortalsVM>(null as any);
    }
}

export class PersonClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPeopleForPortal(portalId: number): Promise<PersonSearchVm> {
        let url_ = this.baseUrl + "/api/Person/byPortal/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPeopleForPortal(_response);
        });
    }

    protected processGetPeopleForPortal(response: Response): Promise<PersonSearchVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonSearchVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonSearchVm>(null as any);
    }

    getPerson(personId: number): Promise<PersonVm> {
        let url_ = this.baseUrl + "/api/Person/getperson/{personId}";
        if (personId === undefined || personId === null)
            throw new Error("The parameter 'personId' must be defined.");
        url_ = url_.replace("{personId}", encodeURIComponent("" + personId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPerson(_response);
        });
    }

    protected processGetPerson(response: Response): Promise<PersonVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PersonVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PersonVm>(null as any);
    }

    tenantAdminSavePerson(portalId: number | undefined, cmd: TenantAdminSavePersonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/tenantadminsaveperson?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenantAdminSavePerson(_response);
        });
    }

    protected processTenantAdminSavePerson(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    clientAdminSavePerson(portalId: number | undefined, cmd: ClientAdminSavePersonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/clientadminsaveperson?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processClientAdminSavePerson(_response);
        });
    }

    protected processClientAdminSavePerson(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    staffSavePerson(cmd: StaffSavePersonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/staffsaveperson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStaffSavePerson(_response);
        });
    }

    protected processStaffSavePerson(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    selfSavePerson(cmd: SelfSavePersonCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Person/selfsaveperson";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSelfSavePerson(_response);
        });
    }

    protected processSelfSavePerson(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getPeopleSearch(portalId: number, searchTerm: string, excludeTestAccounts: boolean | undefined): Promise<PeopleSearchDTO[]> {
        let url_ = this.baseUrl + "/api/Person/personsearch/{portalId}/{searchTerm}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        if (excludeTestAccounts === null)
            throw new Error("The parameter 'excludeTestAccounts' cannot be null.");
        else if (excludeTestAccounts !== undefined)
            url_ += "excludeTestAccounts=" + encodeURIComponent("" + excludeTestAccounts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPeopleSearch(_response);
        });
    }

    protected processGetPeopleSearch(response: Response): Promise<PeopleSearchDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleSearchDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleSearchDTO[]>(null as any);
    }

    getPeopleSearch2(portalId: number, excludeTestAccounts: boolean | undefined): Promise<PeopleSearchDTO[]> {
        let url_ = this.baseUrl + "/api/Person/personsearch/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (excludeTestAccounts === null)
            throw new Error("The parameter 'excludeTestAccounts' cannot be null.");
        else if (excludeTestAccounts !== undefined)
            url_ += "excludeTestAccounts=" + encodeURIComponent("" + excludeTestAccounts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPeopleSearch2(_response);
        });
    }

    protected processGetPeopleSearch2(response: Response): Promise<PeopleSearchDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PeopleSearchDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PeopleSearchDTO[]>(null as any);
    }

    getGlobalPeopleSearch(searchTerm: string): Promise<GlobalPeopleSearchDTO[]> {
        let url_ = this.baseUrl + "/api/Person/globalpersonsearch/{searchTerm}";
        if (searchTerm === undefined || searchTerm === null)
            throw new Error("The parameter 'searchTerm' must be defined.");
        url_ = url_.replace("{searchTerm}", encodeURIComponent("" + searchTerm));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalPeopleSearch(_response);
        });
    }

    protected processGetGlobalPeopleSearch(response: Response): Promise<GlobalPeopleSearchDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlobalPeopleSearchDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalPeopleSearchDTO[]>(null as any);
    }

    getGlobalPeopleSearch2(): Promise<GlobalPeopleSearchDTO[]> {
        let url_ = this.baseUrl + "/api/Person/globalpersonsearch";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetGlobalPeopleSearch2(_response);
        });
    }

    protected processGetGlobalPeopleSearch2(response: Response): Promise<GlobalPeopleSearchDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as GlobalPeopleSearchDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GlobalPeopleSearchDTO[]>(null as any);
    }

    deletePortalTestPeople(portalId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/deleteportaltestpeople/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeletePortalTestPeople(_response);
        });
    }

    protected processDeletePortalTestPeople(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bulkAddPermissions(request: BulkAddPermissionsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/bulkAddPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAddPermissions(_response);
        });
    }

    protected processBulkAddPermissions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    setPortalPermissions(request: SetPortalPermissionsRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/setPortalPermissions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSetPortalPermissions(_response);
        });
    }

    protected processSetPortalPermissions(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    tenantDeleteRegistration(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/tenantDeleteRegistration?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenantDeleteRegistration(_response);
        });
    }

    protected processTenantDeleteRegistration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteRegistration(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/deleteRegistration?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRegistration(_response);
        });
    }

    protected processDeleteRegistration(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    tenantDeactivatePerson(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/tenantDeactivatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenantDeactivatePerson(_response);
        });
    }

    protected processTenantDeactivatePerson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deactivatePerson(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/deactivatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeactivatePerson(_response);
        });
    }

    protected processDeactivatePerson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    tenantReactivatePerson(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/tenantReactivatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processTenantReactivatePerson(_response);
        });
    }

    protected processTenantReactivatePerson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    reactivatePerson(personId: number | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Person/reactivatePerson?";
        if (personId === null)
            throw new Error("The parameter 'personId' cannot be null.");
        else if (personId !== undefined)
            url_ += "personId=" + encodeURIComponent("" + personId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processReactivatePerson(_response);
        });
    }

    protected processReactivatePerson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class PropertyClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getPropertySearch(): Promise<PortalSearchVm> {
        let url_ = this.baseUrl + "/api/Property/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPropertySearch(_response);
        });
    }

    protected processGetPropertySearch(response: Response): Promise<PortalSearchVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalSearchVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalSearchVm>(null as any);
    }

    getPortalsForClient(clientSystemName: string | undefined, regionName: string | null | undefined, permissionFilter: PermissionType | null | undefined): Promise<PortalListDTO[]> {
        let url_ = this.baseUrl + "/api/Property/portallist?";
        if (clientSystemName === null)
            throw new Error("The parameter 'clientSystemName' cannot be null.");
        else if (clientSystemName !== undefined)
            url_ += "clientSystemName=" + encodeURIComponent("" + clientSystemName) + "&";
        if (regionName !== undefined && regionName !== null)
            url_ += "regionName=" + encodeURIComponent("" + regionName) + "&";
        if (permissionFilter !== undefined && permissionFilter !== null)
            url_ += "permissionFilter=" + encodeURIComponent("" + permissionFilter) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortalsForClient(_response);
        });
    }

    protected processGetPortalsForClient(response: Response): Promise<PortalListDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalListDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalListDTO[]>(null as any);
    }

    getInviteCodes(portalId: number): Promise<InviteCodesVm> {
        let url_ = this.baseUrl + "/api/Property/invitecodes/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetInviteCodes(_response);
        });
    }

    protected processGetInviteCodes(response: Response): Promise<InviteCodesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteCodesVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteCodesVm>(null as any);
    }

    lookupInviteCode(portalId: number, code: string): Promise<InviteCodesVm> {
        let url_ = this.baseUrl + "/api/Property/invitecode/{portalId}/{code}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (code === undefined || code === null)
            throw new Error("The parameter 'code' must be defined.");
        url_ = url_.replace("{code}", encodeURIComponent("" + code));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLookupInviteCode(_response);
        });
    }

    protected processLookupInviteCode(response: Response): Promise<InviteCodesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteCodesVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteCodesVm>(null as any);
    }

    getAutoActivateInviteCodes(portalId: number): Promise<InviteCodesVm> {
        let url_ = this.baseUrl + "/api/Property/getautoactivateinvitecodes/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAutoActivateInviteCodes(_response);
        });
    }

    protected processGetAutoActivateInviteCodes(response: Response): Promise<InviteCodesVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InviteCodesVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InviteCodesVm>(null as any);
    }

    getPortalByCode(siteCode: string): Promise<PortalDTO> {
        let url_ = this.baseUrl + "/api/Property/{siteCode}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetPortalByCode(_response);
        });
    }

    protected processGetPortalByCode(response: Response): Promise<PortalDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PortalDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PortalDTO>(null as any);
    }

    saveNumber(cmd: SaveNumberCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/savenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNumber(_response);
        });
    }

    protected processSaveNumber(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getTenantUserCount(tenantId: number | undefined, portalId: number | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/getTenantUserCount?";
        if (tenantId === null)
            throw new Error("The parameter 'tenantId' cannot be null.");
        else if (tenantId !== undefined)
            url_ += "tenantId=" + encodeURIComponent("" + tenantId) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTenantUserCount(_response);
        });
    }

    protected processGetTenantUserCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    disableTenantUsers(cmd: DisableTenantUsersCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/disableTenantUsers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDisableTenantUsers(_response);
        });
    }

    protected processDisableTenantUsers(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveTenant(cmd: SaveTenantCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/savetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTenant(_response);
        });
    }

    protected processSaveTenant(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveTenantOrder(request: SaveTenantOrderRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/savetenantorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTenantOrder(_response);
        });
    }

    protected processSaveTenantOrder(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    bulkSaveTenant(request: BulkTenantRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/bulksavetenant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkSaveTenant(_response);
        });
    }

    protected processBulkSaveTenant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTenant(tenantId: number, portalId: number | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deleteTenant/{tenantId}?";
        if (tenantId === undefined || tenantId === null)
            throw new Error("The parameter 'tenantId' must be defined.");
        url_ = url_.replace("{tenantId}", encodeURIComponent("" + tenantId));
        if (portalId !== undefined && portalId !== null)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTenant(_response);
        });
    }

    protected processDeleteTenant(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteNumber(cmd: DeleteNumberCommand): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deletenumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteNumber(_response);
        });
    }

    protected processDeleteNumber(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveNumberOrder(command: SaveNumberOrderRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/savenumberorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveNumberOrder(_response);
        });
    }

    protected processSaveNumberOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadDocumentFile(documentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/document/{documentId}/download";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocumentFile(_response);
        });
    }

    protected processDownloadDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadDocumentFile2(documentId: number, fileName: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/document/{documentId}/download/{fileName}";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDownloadDocumentFile2(_response);
        });
    }

    protected processDownloadDocumentFile2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    renameDocumentFile(siteCode: string, oldFilename: string, newFilename: string, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/document/rename/{siteCode}/{oldFilename}/{newFilename}?";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (oldFilename === undefined || oldFilename === null)
            throw new Error("The parameter 'oldFilename' must be defined.");
        url_ = url_.replace("{oldFilename}", encodeURIComponent("" + oldFilename));
        if (newFilename === undefined || newFilename === null)
            throw new Error("The parameter 'newFilename' must be defined.");
        url_ = url_.replace("{newFilename}", encodeURIComponent("" + newFilename));
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameDocumentFile(_response);
        });
    }

    protected processRenameDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadDocumentFile(siteCode: string, portalId: number | undefined, oldFilename: string | null | undefined, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/document/upload/{siteCode}?";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        if (oldFilename !== undefined && oldFilename !== null)
            url_ += "oldFilename=" + encodeURIComponent("" + oldFilename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadDocumentFile(_response);
        });
    }

    protected processUploadDocumentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveDocument(command: SaveDocumentCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/document";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDocument(_response);
        });
    }

    protected processSaveDocument(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteDocument(portalId: number | undefined, documentId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deleteDoc/{documentId}?";
        if (documentId === undefined || documentId === null)
            throw new Error("The parameter 'documentId' must be defined.");
        url_ = url_.replace("{documentId}", encodeURIComponent("" + documentId));
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteDocument(_response);
        });
    }

    protected processDeleteDocument(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveDocOrder(command: SaveDocumentOrderRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/savedocorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveDocOrder(_response);
        });
    }

    protected processSaveDocOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveInviteCode(cmd: SaveInviteCodeCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/saveinvitecode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveInviteCode(_response);
        });
    }

    protected processSaveInviteCode(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteInviteCode(inviteCodeId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deleteInviteCode/{inviteCodeId}";
        if (inviteCodeId === undefined || inviteCodeId === null)
            throw new Error("The parameter 'inviteCodeId' must be defined.");
        url_ = url_.replace("{inviteCodeId}", encodeURIComponent("" + inviteCodeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteInviteCode(_response);
        });
    }

    protected processDeleteInviteCode(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveRole(cmd: SaveSiteRoleCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/saverole";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveRole(_response);
        });
    }

    protected processSaveRole(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveRoleOrder(command: SaveSiteRoleOrderRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/saveroleorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveRoleOrder(_response);
        });
    }

    protected processSaveRoleOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteRole(siteRoleId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deleterole/{siteRoleId}";
        if (siteRoleId === undefined || siteRoleId === null)
            throw new Error("The parameter 'siteRoleId' must be defined.");
        url_ = url_.replace("{siteRoleId}", encodeURIComponent("" + siteRoleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRole(_response);
        });
    }

    protected processDeleteRole(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveContent(request: SaveContentRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/content";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveContent(_response);
        });
    }

    protected processSaveContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    uploadContentFile(siteCode: string | undefined, oldFilename: string | null | undefined, file: FileParameter | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/content/upload?";
        if (siteCode === null)
            throw new Error("The parameter 'siteCode' cannot be null.");
        else if (siteCode !== undefined)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        if (oldFilename !== undefined && oldFilename !== null)
            url_ += "oldFilename=" + encodeURIComponent("" + oldFilename) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUploadContentFile(_response);
        });
    }

    protected processUploadContentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    renameContentFile(siteCode: string, oldFilename: string, newFilename: string): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/content/rename/{siteCode}/{oldFilename}/{newFilename}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (oldFilename === undefined || oldFilename === null)
            throw new Error("The parameter 'oldFilename' must be defined.");
        url_ = url_.replace("{oldFilename}", encodeURIComponent("" + oldFilename));
        if (newFilename === undefined || newFilename === null)
            throw new Error("The parameter 'newFilename' must be defined.");
        url_ = url_.replace("{newFilename}", encodeURIComponent("" + newFilename));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRenameContentFile(_response);
        });
    }

    protected processRenameContentFile(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getContentFile(siteCode: string, contentId: number): Promise<ContentDTO> {
        let url_ = this.baseUrl + "/api/Property/content/file/{siteCode}/{contentId}";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (contentId === undefined || contentId === null)
            throw new Error("The parameter 'contentId' must be defined.");
        url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetContentFile(_response);
        });
    }

    protected processGetContentFile(response: Response): Promise<ContentDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ContentDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ContentDTO>(null as any);
    }

    deleteContent(contentId: number | undefined, siteCode: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deletecontent?";
        if (contentId === null)
            throw new Error("The parameter 'contentId' cannot be null.");
        else if (contentId !== undefined)
            url_ += "contentId=" + encodeURIComponent("" + contentId) + "&";
        if (siteCode !== undefined && siteCode !== null)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteContent(_response);
        });
    }

    protected processDeleteContent(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveUserCollection(request: SaveUserCollectionRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Property/saveUserCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveUserCollection(_response);
        });
    }

    protected processSaveUserCollection(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteUserCollection(request: DeleteUserCollectionRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Property/deleteUserCollection";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteUserCollection(_response);
        });
    }

    protected processDeleteUserCollection(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    version(): Promise<string> {
        let url_ = this.baseUrl + "/api/Property/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ReportClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTrainingResults(portalId: number, startDate: Date | null | undefined, endDate: Date | null | undefined, excludeTestUsers: boolean | undefined): Promise<TrainingResultVm> {
        let url_ = this.baseUrl + "/api/Report/training-report/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (startDate !== undefined && startDate !== null)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toISOString() : "") + "&";
        if (endDate !== undefined && endDate !== null)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        if (excludeTestUsers === null)
            throw new Error("The parameter 'excludeTestUsers' cannot be null.");
        else if (excludeTestUsers !== undefined)
            url_ += "excludeTestUsers=" + encodeURIComponent("" + excludeTestUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingResults(_response);
        });
    }

    protected processGetTrainingResults(response: Response): Promise<TrainingResultVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingResultVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingResultVm>(null as any);
    }

    getRoster(portalId: number, excludeTestAccounts: boolean | null | undefined): Promise<RosterPersonDTO[]> {
        let url_ = this.baseUrl + "/api/Report/roster/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (excludeTestAccounts !== undefined && excludeTestAccounts !== null)
            url_ += "excludeTestAccounts=" + encodeURIComponent("" + excludeTestAccounts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRoster(_response);
        });
    }

    protected processGetRoster(response: Response): Promise<RosterPersonDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RosterPersonDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RosterPersonDTO[]>(null as any);
    }

    getVRReport(portalId: number, excludeTestUsers: boolean | undefined): Promise<VRAccomplishmentDTO[]> {
        let url_ = this.baseUrl + "/api/Report/vr-report/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (excludeTestUsers === null)
            throw new Error("The parameter 'excludeTestUsers' cannot be null.");
        else if (excludeTestUsers !== undefined)
            url_ += "excludeTestUsers=" + encodeURIComponent("" + excludeTestUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVRReport(_response);
        });
    }

    protected processGetVRReport(response: Response): Promise<VRAccomplishmentDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRAccomplishmentDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VRAccomplishmentDTO[]>(null as any);
    }

    getVRFilterReport(portalId: number, excludeTestUsers: boolean | undefined): Promise<VRFilterDTO[]> {
        let url_ = this.baseUrl + "/api/Report/vr-filter-report/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (excludeTestUsers === null)
            throw new Error("The parameter 'excludeTestUsers' cannot be null.");
        else if (excludeTestUsers !== undefined)
            url_ += "excludeTestUsers=" + encodeURIComponent("" + excludeTestUsers) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetVRFilterReport(_response);
        });
    }

    protected processGetVRFilterReport(response: Response): Promise<VRFilterDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VRFilterDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VRFilterDTO[]>(null as any);
    }

    getTrainingExpirationReport(portalId: number, excludeTestAccounts: boolean | null | undefined): Promise<TrainingExpirationPersonDTO[]> {
        let url_ = this.baseUrl + "/api/Report/training-expiration-report/{portalId}?";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (excludeTestAccounts !== undefined && excludeTestAccounts !== null)
            url_ += "excludeTestAccounts=" + encodeURIComponent("" + excludeTestAccounts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingExpirationReport(_response);
        });
    }

    protected processGetTrainingExpirationReport(response: Response): Promise<TrainingExpirationPersonDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingExpirationPersonDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingExpirationPersonDTO[]>(null as any);
    }
}

export class RespondClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getLibraryList(): Promise<SimpleResponseLibDTO[]> {
        let url_ = this.baseUrl + "/api/Respond/libraries";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLibraryList(_response);
        });
    }

    protected processGetLibraryList(response: Response): Promise<SimpleResponseLibDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleResponseLibDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleResponseLibDTO[]>(null as any);
    }

    getLibrary(responseLibId: number): Promise<ResponseLibDTO> {
        let url_ = this.baseUrl + "/api/Respond/library/{responseLibId}";
        if (responseLibId === undefined || responseLibId === null)
            throw new Error("The parameter 'responseLibId' must be defined.");
        url_ = url_.replace("{responseLibId}", encodeURIComponent("" + responseLibId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetLibrary(_response);
        });
    }

    protected processGetLibrary(response: Response): Promise<ResponseLibDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseLibDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseLibDTO>(null as any);
    }

    getResponseTypes(): Promise<ResponseTypeDTO2[]> {
        let url_ = this.baseUrl + "/api/Respond/responsetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResponseTypes(_response);
        });
    }

    protected processGetResponseTypes(response: Response): Promise<ResponseTypeDTO2[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseTypeDTO2[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseTypeDTO2[]>(null as any);
    }

    saveResponseType(request: SaveResponseTypeRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Respond/responsetype";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponseType(_response);
        });
    }

    protected processSaveResponseType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getResponsesByPortal(portalId: number, includeHidden: boolean): Promise<ResponseDTO[]> {
        let url_ = this.baseUrl + "/api/Respond/responsesByPortal/{portalId}/{includeHidden}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        if (includeHidden === undefined || includeHidden === null)
            throw new Error("The parameter 'includeHidden' must be defined.");
        url_ = url_.replace("{includeHidden}", encodeURIComponent("" + includeHidden));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResponsesByPortal(_response);
        });
    }

    protected processGetResponsesByPortal(response: Response): Promise<ResponseDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseDTO[]>(null as any);
    }

    getExcludedResponseTypes(portalId: number): Promise<ExcludedResponseTypeDTO[]> {
        let url_ = this.baseUrl + "/api/Respond/excludedresponsetypes/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetExcludedResponseTypes(_response);
        });
    }

    protected processGetExcludedResponseTypes(response: Response): Promise<ExcludedResponseTypeDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcludedResponseTypeDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExcludedResponseTypeDTO[]>(null as any);
    }

    saveResponseVisibility(request: ResponseVisibilityRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Respond/saveresponsevisibility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponseVisibility(_response);
        });
    }

    protected processSaveResponseVisibility(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveResponse(portalId: number | undefined, command: SaveResponse): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/saveresponse?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponse(_response);
        });
    }

    protected processSaveResponse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    saveResponseLibrary(command: SaveResponseLib): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/saveresponselib";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponseLibrary(_response);
        });
    }

    protected processSaveResponseLibrary(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteResponse(responseId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/deleteresponse/{responseId}";
        if (responseId === undefined || responseId === null)
            throw new Error("The parameter 'responseId' must be defined.");
        url_ = url_.replace("{responseId}", encodeURIComponent("" + responseId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResponse(_response);
        });
    }

    protected processDeleteResponse(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteResponseLibItem(responseLibItemId: number): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/deleteresponselibitem/{responseLibItemId}";
        if (responseLibItemId === undefined || responseLibItemId === null)
            throw new Error("The parameter 'responseLibItemId' must be defined.");
        url_ = url_.replace("{responseLibItemId}", encodeURIComponent("" + responseLibItemId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResponseLibItem(_response);
        });
    }

    protected processDeleteResponseLibItem(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteResponseType(responseTypeId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Respond/deleteresponsetype?";
        if (responseTypeId === null)
            throw new Error("The parameter 'responseTypeId' cannot be null.");
        else if (responseTypeId !== undefined)
            url_ += "responseTypeId=" + encodeURIComponent("" + responseTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResponseType(_response);
        });
    }

    protected processDeleteResponseType(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteResponseLibrary(responseLibId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Respond/deletelibrary/{responseLibId}";
        if (responseLibId === undefined || responseLibId === null)
            throw new Error("The parameter 'responseLibId' must be defined.");
        url_ = url_.replace("{responseLibId}", encodeURIComponent("" + responseLibId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteResponseLibrary(_response);
        });
    }

    protected processDeleteResponseLibrary(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveResponseLibItem(command: SaveResponseLibItem): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/saveresponselibitem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponseLibItem(_response);
        });
    }

    protected processSaveResponseLibItem(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    searchAllResponseContent(request: SearchAllResponseContentRequest): Promise<SearchResponseResultsDTO> {
        let url_ = this.baseUrl + "/api/Respond/search/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchAllResponseContent(_response);
        });
    }

    protected processSearchAllResponseContent(response: Response): Promise<SearchResponseResultsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResponseResultsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponseResultsDTO>(null as any);
    }

    searchResponseContentByLibrary(request: SearchResponseContentByLibraryRequest): Promise<SearchResponseResultsDTO> {
        let url_ = this.baseUrl + "/api/Respond/search/bylibrary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchResponseContentByLibrary(_response);
        });
    }

    protected processSearchResponseContentByLibrary(response: Response): Promise<SearchResponseResultsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResponseResultsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponseResultsDTO>(null as any);
    }

    searchResponseContentByPortal(request: SearchResponseContentByPortalRequest): Promise<SearchResponseResultsDTO> {
        let url_ = this.baseUrl + "/api/Respond/search/byportal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSearchResponseContentByPortal(_response);
        });
    }

    protected processSearchResponseContentByPortal(response: Response): Promise<SearchResponseResultsDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SearchResponseResultsDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SearchResponseResultsDTO>(null as any);
    }

    saveResponsePortalOrder(request: ResponseTypeOrderRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Respond/saverespondorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResponsePortalOrder(_response);
        });
    }

    protected processSaveResponsePortalOrder(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    getResponseScenarios(responseLibId: number | undefined): Promise<ResponseScenariosDTO> {
        let url_ = this.baseUrl + "/api/Respond/getrespondscenarios?";
        if (responseLibId === null)
            throw new Error("The parameter 'responseLibId' cannot be null.");
        else if (responseLibId !== undefined)
            url_ += "responseLibId=" + encodeURIComponent("" + responseLibId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetResponseScenarios(_response);
        });
    }

    protected processGetResponseScenarios(response: Response): Promise<ResponseScenariosDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ResponseScenariosDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ResponseScenariosDTO>(null as any);
    }
}

export class SamlClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    samlLogoutPOST(sAMLResponse: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Saml/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sAMLResponse !== null && sAMLResponse !== undefined)
            content_.append("SAMLResponse", sAMLResponse.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSamlLogoutPOST(_response);
        });
    }

    protected processSamlLogoutPOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    samlLogoutGET(sAMLResponse: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Saml/logout";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sAMLResponse !== null && sAMLResponse !== undefined)
            content_.append("SAMLResponse", sAMLResponse.toString());

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSamlLogoutGET(_response);
        });
    }

    protected processSamlLogoutGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    samlConsumePOST(sAMLResponse: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Saml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sAMLResponse !== null && sAMLResponse !== undefined)
            content_.append("SAMLResponse", sAMLResponse.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSamlConsumePOST(_response);
        });
    }

    protected processSamlConsumePOST(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    samlConsumeGET(sAMLResponse: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Saml";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sAMLResponse !== null && sAMLResponse !== undefined)
            content_.append("SAMLResponse", sAMLResponse.toString());

        let options_: RequestInit = {
            body: content_,
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSamlConsumeGET(_response);
        });
    }

    protected processSamlConsumeGET(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    samlConsumePOST2(signInTarget: string, sAMLResponse: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Saml/{signInTarget}";
        if (signInTarget === undefined || signInTarget === null)
            throw new Error("The parameter 'signInTarget' must be defined.");
        url_ = url_.replace("{signInTarget}", encodeURIComponent("" + signInTarget));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (sAMLResponse !== null && sAMLResponse !== undefined)
            content_.append("SAMLResponse", sAMLResponse.toString());

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSamlConsumePOST2(_response);
        });
    }

    protected processSamlConsumePOST2(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TrainingClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    getTrainingProgramList(): Promise<SimpleTrainingProgramDTO[]> {
        let url_ = this.baseUrl + "/api/Training/trainingprogram/list";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingProgramList(_response);
        });
    }

    protected processGetTrainingProgramList(response: Response): Promise<SimpleTrainingProgramDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimpleTrainingProgramDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimpleTrainingProgramDTO[]>(null as any);
    }

    getTrainingProgram(trainingProgramId: number): Promise<TrainingProgramDTO> {
        let url_ = this.baseUrl + "/api/Training/trainingprogram/{trainingProgramId}";
        if (trainingProgramId === undefined || trainingProgramId === null)
            throw new Error("The parameter 'trainingProgramId' must be defined.");
        url_ = url_.replace("{trainingProgramId}", encodeURIComponent("" + trainingProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingProgram(_response);
        });
    }

    protected processGetTrainingProgram(response: Response): Promise<TrainingProgramDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingProgramDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingProgramDTO>(null as any);
    }

    getTrainingProgramsByPortal(portalId: number): Promise<TrainingProgramDTO[]> {
        let url_ = this.baseUrl + "/api/Training/trainingprogram/byportal/{portalId}";
        if (portalId === undefined || portalId === null)
            throw new Error("The parameter 'portalId' must be defined.");
        url_ = url_.replace("{portalId}", encodeURIComponent("" + portalId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingProgramsByPortal(_response);
        });
    }

    protected processGetTrainingProgramsByPortal(response: Response): Promise<TrainingProgramDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingProgramDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingProgramDTO[]>(null as any);
    }

    saveTrainingProgram(cmd: SaveTrainingProgram): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/trainingprogram";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTrainingProgram(_response);
        });
    }

    protected processSaveTrainingProgram(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    importTrainingProgramsFromPortal(request: ImportTrainingProgramsFromPortalRequest): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/trainingprogram/import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImportTrainingProgramsFromPortal(_response);
        });
    }

    protected processImportTrainingProgramsFromPortal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteTrainingProgram(trainingProgramId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/deletetrainingprogram/{trainingProgramId}";
        if (trainingProgramId === undefined || trainingProgramId === null)
            throw new Error("The parameter 'trainingProgramId' must be defined.");
        url_ = url_.replace("{trainingProgramId}", encodeURIComponent("" + trainingProgramId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrainingProgram(_response);
        });
    }

    protected processDeleteTrainingProgram(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTrainingModule(trainingModuleId: number): Promise<TrainingModuleDTO> {
        let url_ = this.baseUrl + "/api/Training/trainingmodule/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTrainingModule(_response);
        });
    }

    protected processGetTrainingModule(response: Response): Promise<TrainingModuleDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TrainingModuleDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TrainingModuleDTO>(null as any);
    }

    saveTrainingModule(cmd: SaveTrainingModule): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/trainingmodule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTrainingModule(_response);
        });
    }

    protected processSaveTrainingModule(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTrainingModule(trainingModuleId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/deletetrainingmodule/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTrainingModule(_response);
        });
    }

    protected processDeleteTrainingModule(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getTest(testId: number): Promise<TestDTO> {
        let url_ = this.baseUrl + "/api/Training/test/{testId}";
        if (testId === undefined || testId === null)
            throw new Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTest(_response);
        });
    }

    protected processGetTest(response: Response): Promise<TestDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestDTO>(null as any);
    }

    getTestsByTrainingModule(trainingModuleId: number): Promise<TestDTO[]> {
        let url_ = this.baseUrl + "/api/Training/test/bymodule/{trainingModuleId}";
        if (trainingModuleId === undefined || trainingModuleId === null)
            throw new Error("The parameter 'trainingModuleId' must be defined.");
        url_ = url_.replace("{trainingModuleId}", encodeURIComponent("" + trainingModuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetTestsByTrainingModule(_response);
        });
    }

    protected processGetTestsByTrainingModule(response: Response): Promise<TestDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TestDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TestDTO[]>(null as any);
    }

    saveTest(cmd: Request): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/test";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveTest(_response);
        });
    }

    protected processSaveTest(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTest(testId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/deletetest/{testId}";
        if (testId === undefined || testId === null)
            throw new Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteTest(_response);
        });
    }

    protected processDeleteTest(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getQuestion(questionId: number): Promise<QuestionDTO> {
        let url_ = this.baseUrl + "/api/Training/question/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestion(_response);
        });
    }

    protected processGetQuestion(response: Response): Promise<QuestionDTO> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionDTO;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDTO>(null as any);
    }

    getQuestionsByTest(testId: number): Promise<QuestionDTO[]> {
        let url_ = this.baseUrl + "/api/Training/question/bytest/{testId}";
        if (testId === undefined || testId === null)
            throw new Error("The parameter 'testId' must be defined.");
        url_ = url_.replace("{testId}", encodeURIComponent("" + testId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetQuestionsByTest(_response);
        });
    }

    protected processGetQuestionsByTest(response: Response): Promise<QuestionDTO[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as QuestionDTO[];
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuestionDTO[]>(null as any);
    }

    saveQuestion(cmd: Request2): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/question";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveQuestion(_response);
        });
    }

    protected processSaveQuestion(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteQuestion(questionId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/deletequestion/{questionId}";
        if (questionId === undefined || questionId === null)
            throw new Error("The parameter 'questionId' must be defined.");
        url_ = url_.replace("{questionId}", encodeURIComponent("" + questionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteQuestion(_response);
        });
    }

    protected processDeleteQuestion(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveAnswer(cmd: Request3): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/answer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveAnswer(_response);
        });
    }

    protected processSaveAnswer(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    deleteAnswer(answerId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/Training/deleteanswer/{answerId}";
        if (answerId === undefined || answerId === null)
            throw new Error("The parameter 'answerId' must be defined.");
        url_ = url_.replace("{answerId}", encodeURIComponent("" + answerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteAnswer(_response);
        });
    }

    protected processDeleteAnswer(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveResult(cmd: Request4): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/result";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(cmd);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processSaveResult(_response);
        });
    }

    protected processSaveResult(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    bulkRemoveTrainingProgramPermission(request: BulkRemoveTrainingProgramPermissionRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/bulkremovetrainingpermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkRemoveTrainingProgramPermission(_response);
        });
    }

    protected processBulkRemoveTrainingProgramPermission(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    bulkAddTrainingProgramPermission(request: BulkAddTrainingProgramPermissionRequest): Promise<number> {
        let url_ = this.baseUrl + "/api/Training/bulkaddtrainingpermission";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processBulkAddTrainingProgramPermission(_response);
        });
    }

    protected processBulkAddTrainingProgramPermission(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export class UserClient extends ClientBase {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl ?? "";
    }

    register(input: RegisterRequest): Promise<string> {
        let url_ = this.baseUrl + "/api/User/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    redirectToExternal(provider: string | undefined, returnUrl: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/external?";
        if (provider === null)
            throw new Error("The parameter 'provider' cannot be null.");
        else if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&";
        if (returnUrl === null)
            throw new Error("The parameter 'returnUrl' cannot be null.");
        else if (returnUrl !== undefined)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRedirectToExternal(_response);
        });
    }

    protected processRedirectToExternal(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    externalCallback(siteCode: string, returnUrl: string | null | undefined, remoteError: string | null | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/callback/{siteCode}?";
        if (siteCode === undefined || siteCode === null)
            throw new Error("The parameter 'siteCode' must be defined.");
        url_ = url_.replace("{siteCode}", encodeURIComponent("" + siteCode));
        if (returnUrl !== undefined && returnUrl !== null)
            url_ += "returnUrl=" + encodeURIComponent("" + returnUrl) + "&";
        if (remoteError !== undefined && remoteError !== null)
            url_ += "remoteError=" + encodeURIComponent("" + remoteError) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processExternalCallback(_response);
        });
    }

    protected processExternalCallback(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    token(): Promise<string> {
        let url_ = this.baseUrl + "/api/User/token";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processToken(_response);
        });
    }

    protected processToken(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getUser(portalId: number | undefined, clientSystemName: string | undefined): Promise<LoginVm> {
        let url_ = this.baseUrl + "/api/User?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        if (clientSystemName === null)
            throw new Error("The parameter 'clientSystemName' cannot be null.");
        else if (clientSystemName !== undefined)
            url_ += "clientSystemName=" + encodeURIComponent("" + clientSystemName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUser(_response);
        });
    }

    protected processGetUser(response: Response): Promise<LoginVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginVm>(null as any);
    }

    getUserWithToken(portalId: number | undefined, clientSystemName: string | undefined, siteCode: string | undefined): Promise<LoginVm> {
        let url_ = this.baseUrl + "/api/User/getuserwithtoken?";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        if (clientSystemName === null)
            throw new Error("The parameter 'clientSystemName' cannot be null.");
        else if (clientSystemName !== undefined)
            url_ += "clientSystemName=" + encodeURIComponent("" + clientSystemName) + "&";
        if (siteCode === null)
            throw new Error("The parameter 'siteCode' cannot be null.");
        else if (siteCode !== undefined)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetUserWithToken(_response);
        });
    }

    protected processGetUserWithToken(response: Response): Promise<LoginVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginVm>(null as any);
    }

    login(login: LoginRequest): Promise<LoginVm> {
        let url_ = this.baseUrl + "/api/User/login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: Response): Promise<LoginVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginVm>(null as any);
    }

    impersonate(login: ImpersonateRequest): Promise<LoginVm> {
        let url_ = this.baseUrl + "/api/User/impersonate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(login);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processImpersonate(_response);
        });
    }

    protected processImpersonate(response: Response): Promise<LoginVm> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as LoginVm;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LoginVm>(null as any);
    }

    logout(): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    requestPasswordReset(username: string | undefined, siteCode: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/requestPasswordReset?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (siteCode === null)
            throw new Error("The parameter 'siteCode' cannot be null.");
        else if (siteCode !== undefined)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestPasswordReset(_response);
        });
    }

    protected processRequestPasswordReset(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    passwordReset(username: string | undefined, code: string | undefined, password: string | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/passwordReset?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        if (password === null)
            throw new Error("The parameter 'password' cannot be null.");
        else if (password !== undefined)
            url_ += "password=" + encodeURIComponent("" + password) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processPasswordReset(_response);
        });
    }

    protected processPasswordReset(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upgradePassword(username: string | undefined, oldpassword: string | undefined, newpassword: string | undefined, portalId: number | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/upgradePassword?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (oldpassword === null)
            throw new Error("The parameter 'oldpassword' cannot be null.");
        else if (oldpassword !== undefined)
            url_ += "oldpassword=" + encodeURIComponent("" + oldpassword) + "&";
        if (newpassword === null)
            throw new Error("The parameter 'newpassword' cannot be null.");
        else if (newpassword !== undefined)
            url_ += "newpassword=" + encodeURIComponent("" + newpassword) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processUpgradePassword(_response);
        });
    }

    protected processUpgradePassword(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    requestEmailVerification(username: string | undefined, siteCode: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/requestEmailVerification?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (siteCode === null)
            throw new Error("The parameter 'siteCode' cannot be null.");
        else if (siteCode !== undefined)
            url_ += "siteCode=" + encodeURIComponent("" + siteCode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processRequestEmailVerification(_response);
        });
    }

    protected processRequestEmailVerification(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    verifyEmail(username: string | undefined, code: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/verifyEmail?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (code === null)
            throw new Error("The parameter 'code' cannot be null.");
        else if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processVerifyEmail(_response);
        });
    }

    protected processVerifyEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    staffForceVerifyEmail(username: string | undefined): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/User/staffForceVerifyEmail?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processStaffForceVerifyEmail(_response);
        });
    }

    protected processStaffForceVerifyEmail(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    checkClient(clientSystemName: string | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/CheckClient?";
        if (clientSystemName === null)
            throw new Error("The parameter 'clientSystemName' cannot be null.");
        else if (clientSystemName !== undefined)
            url_ += "clientSystemName=" + encodeURIComponent("" + clientSystemName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCheckClient(_response);
        });
    }

    protected processCheckClient(response: Response): Promise<boolean> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as boolean;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<boolean>(null as any);
    }

    needsUpgrade(username: string | undefined, portalId: number | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/User/needsupgrade?";
        if (username === null)
            throw new Error("The parameter 'username' cannot be null.");
        else if (username !== undefined)
            url_ += "username=" + encodeURIComponent("" + username) + "&";
        if (portalId === null)
            throw new Error("The parameter 'portalId' cannot be null.");
        else if (portalId !== undefined)
            url_ += "portalId=" + encodeURIComponent("" + portalId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processNeedsUpgrade(_response);
        });
    }

    protected processNeedsUpgrade(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }
}

export interface ClientsVm {
    clients?: ClientDTO[] | undefined;
}

export interface ClientDTO {
    clientId?: number;
    name?: string;
    expireAfterMonths?: number;
    minimumScorePasses?: number;
    categoryAlias?: string;
    categoryValues?: string[] | undefined;
    note?: string | undefined;
    enableBuildingPickerForAllUsers?: boolean;
    systemName?: string;
}

export interface PortalDTO {
    portalId?: number;
    propertyId?: number;
    clientId?: number;
    siteCode?: string;
    siteCodeAlias?: string | undefined;
    responseLibId?: number | undefined;
    name?: string;
    systemName?: string;
    category?: string;
    propertyType?: PropertyType;
    floorList?: string[] | undefined;
    defaultFloor?: string | undefined;
    domainWhiteList?: string[] | undefined;
    tenantAlias?: string | undefined;
    accessibilityNotificationEmail?: string | undefined;
    clientName?: string;
    clientSystemName?: string;
    minimumScorePasses?: number;
    clientEnableBuildingPickerForAllUsers?: boolean;
    isTrainingEnabled?: boolean;
    showExitButtonAtEndOfModule?: boolean;
    showFinishButtonAtEndOfQuiz?: boolean;
    isRespondEnabled?: boolean;
    respondAnonView?: boolean;
    isStaffDirEnabled?: boolean;
    isAlertEnabled?: boolean;
    isMobilityCheckEnabled?: boolean;
    isVrtourEnabled?: boolean;
    hideAllAnonymousContent?: boolean;
    serverVersion?: string | undefined;
    isPasswordLoginEnabled?: boolean;
    usesSharedPasswordMode?: boolean;
    ssoLoginUrl?: string;
    ssoButtonLabel?: string;
    ssoCert?: string | undefined;
    tenantMapParam?: string | undefined;
    isActive?: boolean | undefined;
    isAzureAdEnabled?: boolean;
    isSSORegistrationEnabled?: boolean;
    isSSOEnabled?: boolean;
    alertOriginationNumber?: string | undefined;
    inviteCodeFieldsHidden?: boolean;
    isExpirationEmailsEnabled?: boolean;
    emailTemplateSettingId?: number | undefined;
    isMultiAlertEnabled?: boolean;
    isPushNotificationsEnabled?: boolean | undefined;
    numbers?: NumberDTO[] | undefined;
    documents?: DocumentDTO[] | undefined;
    siteRoles?: SiteRoleDTO[] | undefined;
    trainingPrograms?: PortalTrainingProgramDTO[] | undefined;
    tenants?: TenantDTO[] | undefined;
    responseTypes?: ResponseTypeDTO[] | undefined;
    staffDir?: PersonPortalDTO[] | undefined;
    userCollections?: UserCollectionDTO[] | undefined;
    content?: PortalContentDTO[] | undefined;
}

export enum PropertyType {
    None = 0,
    MixedUse = 1,
    SingleTenant = 2,
    Residential = 3,
    MultiBuilding = 4,
}

export interface NumberDTO {
    numberId?: number;
    portalId?: number;
    label?: string | undefined;
    subLabel?: string | undefined;
    emergencyNumber?: string | undefined;
    allowAnonView?: boolean;
    sortOrder?: number;
    siteRoles?: SiteRoleDTO[];
}

export interface SiteRoleDTO {
    siteRoleId?: number;
    portalId?: number;
    roleTypeId?: number;
    roleAlias?: string | undefined;
    systemName?: string | undefined;
    sortOrder?: number;
    isStaffRole?: boolean;
    isExcludedFromResponses?: boolean;
}

export interface DocumentDTO {
    documentId?: number;
    portalId?: number;
    label?: string | undefined;
    fileName?: string | undefined;
    filePath?: string | undefined;
    mimeType?: string;
    allowAnonLinkView?: boolean;
    allowAnonDownload?: boolean;
    sortOrder?: number;
    fileSize?: number;
    version?: number;
    isAvailableOffline?: boolean;
    siteRoles?: SiteRoleDTO[];
    portal?: Portal | undefined;
}

export interface Portal {
    portalId?: number;
    siteCode?: string;
    siteCodeAlias?: string | undefined;
    responseLibId?: number | undefined;
    isTrainingEnabled?: boolean | undefined;
    showExitButtonAtEndOfModule?: boolean | undefined;
    showFinishButtonAtEndOfQuiz?: boolean | undefined;
    isRespondEnabled?: boolean | undefined;
    respondAnonView?: boolean | undefined;
    isStaffDirEnabled?: boolean | undefined;
    isAlertEnabled?: boolean | undefined;
    isMobilityCheckEnabled?: boolean | undefined;
    isVrtourEnabled?: boolean | undefined;
    usesSharedPasswordMode?: boolean;
    hideAllAnonymousContent?: boolean;
    isActive?: boolean | undefined;
    alertEmailSubject?: string | undefined;
    propertyId?: number | undefined;
    accessibilityNotificationEmail?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    isAzureAdEnabled?: boolean;
    isSSORegistrationEnabled?: boolean;
    isPasswordLoginEnabled?: boolean;
    ssoButtonLabel?: string | undefined;
    ssoLoginUrl?: string | undefined;
    ssoCert?: string | undefined;
    tenantMapParam?: string | undefined;
    isSSOEnabled?: boolean;
    alertOriginationNumber?: string | undefined;
    inviteCodeFieldsHidden?: boolean;
    isExpirationEmailsEnabled?: boolean;
    emailTemplateSettingId?: number | undefined;
    isMultiAlertEnabled?: boolean | undefined;
    isPushNotificationsEnabled?: boolean | undefined;
    property?: Property;
    responseLib?: ResponseLib | undefined;
    excludedResponseTypes?: ResponseType[];
    alertHistories?: AlertHistory[];
    content?: Content[];
    documents?: Document[];
    inviteCodes?: InviteCode[];
    numbers?: Number[];
    registrations?: Registration[];
    siteRoles?: SiteRole[];
    templates?: Template[];
    trainingModules?: TrainingModule[];
    trainingPrograms?: TrainingProgram[];
    userCollections?: UserCollection[];
    links?: Link[];
    linkSections?: LinkSection[];
    responsePortalSorts?: ResponsePortalSort[];
    emailTemplateSetting?: Setting | undefined;
}

export interface Property {
    propertyId?: number;
    name?: string;
    category?: string | undefined;
    clientId?: number;
    propertyType?: PropertyType;
    systemName?: string | undefined;
    floorList?: string | undefined;
    defaultFloor?: string | undefined;
    domainWhiteList?: string | undefined;
    accessibilityNotificationEmail?: string | undefined;
    tenantAlias?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    client?: Client;
    tenants?: Tenant[];
    portals?: Portal[];
}

export interface Client {
    clientId?: number;
    name?: string;
    expireAfterMonths?: number;
    minimumScorePasses?: number;
    categoryAlias?: string;
    categoryValues?: string;
    note?: string | undefined;
    enableBuildingPickerForAllUsers?: boolean;
    systemName?: string;
    properties?: Property[];
}

export interface Tenant {
    tenantId?: number;
    propertyId?: number;
    name?: string;
    systemName?: string;
    vrLaunchUrl?: string;
    ssoMatchValues?: string | undefined;
    isSsoDefault?: boolean | undefined;
    emailDomainMatch?: string | undefined;
    isActive?: boolean | undefined;
    isRestricted?: boolean | undefined;
    sortOrder?: number;
    isEmailVerificationRequired?: boolean;
    property?: Property | undefined;
    registrations?: Registration[] | undefined;
    inviteCodes?: InviteCode[] | undefined;
}

export interface Registration {
    registrationId?: number;
    personId?: number;
    portalId?: number;
    dateRegistered?: Date;
    tenantId?: number | undefined;
    siteRoleId?: number | undefined;
    isHomePortal?: boolean;
    isComplete?: boolean;
    isVisibleStaffDirectory?: boolean;
    isTenantAdmin?: boolean;
    person?: Person;
    siteRole?: SiteRole | undefined;
    tenant?: Tenant | undefined;
    portal?: Portal;
    permissions?: Permission[];
}

export interface Person {
    personId?: number;
    loginEmail?: string;
    password?: string | undefined;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    primaryPhone?: string | undefined;
    mobilePhone?: string | undefined;
    contactEmail?: string | undefined;
    contactEmailVerifiedDate?: Date | undefined;
    contactSms?: string | undefined;
    contactSMSOptOutDate?: Date | undefined;
    pushOptOutDate?: Date | undefined;
    alertSubscribedFloors?: string | undefined;
    isTenantContact?: boolean | undefined;
    isSamlLogin?: boolean | undefined;
    isVrAdmin?: boolean | undefined;
    isOldVradmin?: boolean | undefined;
    createdDate?: Date | undefined;
    updatedDate?: Date | undefined;
    acceptedTermsDate?: Date | undefined;
    updatedAlertContactsDate?: Date | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    dateDisabled?: Date | undefined;
    trainingEmailSent?: Date | undefined;
    roleName?: string;
    loginHistories?: LoginHistory[];
    alertHistories?: AlertHistory[];
    registrations?: Registration[];
    results?: Result[];
    staffNotificationResolutions?: StaffNotification[];
    userUserCollections?: UserUserCollection[];
    pushSubscriptions?: PushSubscription[];
}

export interface LoginHistory {
    id?: number;
    userId?: string | undefined;
    personId?: number;
    loginTime?: Date;
    details?: string | undefined;
    person?: Person;
}

export interface AlertHistory {
    alertHistoryId?: number;
    portalId?: number;
    senderPersonId?: number;
    dateSent?: Date;
    smsList?: string | undefined;
    emailList?: string | undefined;
    messageText?: string | undefined;
    messageLog?: string | undefined;
    messageError?: string | undefined;
    dateUpdated?: Date | undefined;
    filter?: string | undefined;
    senderPerson?: Person | undefined;
    portal?: Portal | undefined;
    alertHistoryDetails?: AlertHistoryDetails[];
}

export interface AlertHistoryDetails {
    alertHistoryDetailsId?: number;
    alertHistoryId?: number | undefined;
    personId?: number | undefined;
    timeStamp?: Date;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    eventType?: string | undefined;
    fullDetails?: string | undefined;
    pushToken?: string | undefined;
    callbackDetails?: string | undefined;
    callbackSuccess?: boolean | undefined;
}

export interface Result {
    resultId?: number;
    personId?: number;
    testId?: number;
    trainingModuleId?: number;
    isPassingScore?: boolean | undefined;
    correctAnswerCount?: number;
    questionCount?: number;
    dateStarted?: Date;
    dateCompleted?: Date | undefined;
    isExpired?: boolean | undefined;
    person?: Person | undefined;
    test?: Test | undefined;
    trainingModule?: TrainingModule | undefined;
    selections?: Selection[];
}

export interface Test {
    testId?: number;
    moduleId?: number;
    title?: string;
    isActive?: boolean | undefined;
    dateExpired?: Date | undefined;
    module?: TrainingModule | undefined;
    questions?: Question[];
    results?: Result[] | undefined;
}

export interface TrainingModule {
    trainingModuleId?: number;
    trainingProgramId?: number;
    name?: string;
    portalId?: number;
    videoId?: number | undefined;
    reviewVideoId?: number | undefined;
    isActive?: boolean | undefined;
    sortOrder?: number | undefined;
    trainingProgram?: TrainingProgram;
    video?: Video | undefined;
    reviewVideo?: Video | undefined;
    portal?: Portal;
    results?: Result[];
    tests?: Test[];
}

export interface TrainingProgram {
    trainingProgramId?: number;
    portalId?: number;
    name?: string;
    isActive?: boolean | undefined;
    v4Password?: string | undefined;
    createdDate?: Date;
    updateDate?: Date | undefined;
    portal?: Portal | undefined;
    inviteCodeTrainingPrograms?: InviteCodeTrainingProgram[] | undefined;
    numbers?: Number[] | undefined;
    permissions?: Permission[] | undefined;
    trainingModules?: TrainingModule[];
}

export interface InviteCodeTrainingProgram {
    inviteCodeTrainingProgramId?: number;
    inviteCodeId?: number;
    trainingProgramId?: number;
    inviteCode?: InviteCode | undefined;
    trainingProgram?: TrainingProgram | undefined;
}

export interface InviteCode {
    inviteCodeId?: number;
    code?: string;
    portalId?: number;
    enableStaffRoles?: boolean | undefined;
    autoActivateSSO?: boolean | undefined;
    autoActivateV4Upgrade?: boolean | undefined;
    autoActivateForVerifiedEmails?: boolean | undefined;
    dateCreated?: Date;
    dateExpired?: Date | undefined;
    activatedTenantId?: number | undefined;
    portal?: Portal | undefined;
    inviteCodeTrainingPrograms?: InviteCodeTrainingProgram[];
    inviteCodePermissions?: InviteCodePermission[];
    activatedTenant?: Tenant | undefined;
}

export interface InviteCodePermission {
    inviteCodePermissionId?: number;
    inviteCodeId?: number;
    permissionType?: PermissionType;
    inviteCode?: InviteCode | undefined;
}

export enum PermissionType {
    ViewTrainingReport = 0,
    ViewPortalRoster = 1,
    ViewMobilityReport = 2,
    ViewVRReport = 3,
    ViewUsers = 4,
    EditDocuments = 5,
    EditContacts = 6,
    ViewAlertSubscriptions = 7,
    SendAlerts = 8,
    ViewVRFilterReport = 9,
    ViewTenantContactReport = 10,
    EditUsers = 11,
    EditRespond = 12,
    EditTenant = 13,
    EditUserCollection = 14,
}

export interface Number {
    numberId?: number;
    portalId?: number;
    label?: string;
    subLabel?: string | undefined;
    emergencyNumber?: string;
    allowAnonView?: boolean;
    sortOrder?: number;
    portal?: Portal | undefined;
    siteRoles?: SiteRole[];
}

export interface SiteRole {
    siteRoleId?: number;
    roleTypeId?: number;
    portalId?: number;
    roleAlias?: string;
    sortOrder?: number | undefined;
    isExcludedFromResponses?: boolean;
    roleType?: RoleType;
    portal?: Portal;
    registrations?: Registration[] | undefined;
    responses?: AkResponse[] | undefined;
    documents?: Document[] | undefined;
    numbers?: Number[] | undefined;
}

export interface RoleType {
    roleTypeId?: number;
    name?: string;
    systemName?: string | undefined;
    isStaffRole?: boolean | undefined;
    isPinned?: boolean;
    responseLibItems?: ResponseLibItem[] | undefined;
    siteRoles?: SiteRole[] | undefined;
    domainEvents?: DomainEvent[];
}

export interface ResponseLibItem {
    responseLibItemId?: number;
    responseLibId?: number;
    responseTypeId?: number;
    roleTypeId?: number;
    responseText?: string;
    responseLib?: ResponseLib;
    responseType?: ResponseType;
    roleType?: RoleType;
    responses?: AkResponse[];
}

export interface ResponseLib {
    responseLibId?: number;
    name?: string;
    responseLibItems?: ResponseLibItem[];
    portals?: Portal[];
}

export interface ResponseType {
    responseTypeId?: number;
    name?: string;
    systemName?: string | undefined;
    responseLibItems?: ResponseLibItem[] | undefined;
    excludingPortals?: Portal[];
    responsePortalSorts?: ResponsePortalSort[];
}

export interface ResponsePortalSort {
    responsePortalSortId?: number;
    responseTypeId?: number;
    portalId?: number;
    sortOrder?: number;
    responseType?: ResponseType;
    portal?: Portal;
}

export interface AkResponse {
    responseId?: number;
    responseLibItemId?: number;
    siteRoleId?: number;
    responseText?: string | undefined;
    isHidden?: boolean | undefined;
    responseLibItem?: ResponseLibItem;
    siteRole?: SiteRole;
}

export interface DomainEvent {
    isPublished?: boolean;
    dateOccurred?: Date;
}

export interface Document {
    documentId?: number;
    portalId?: number | undefined;
    label?: string;
    fileName?: string | undefined;
    filePath?: string | undefined;
    mimeType?: string;
    createdDate?: Date;
    allowAnonLinkView?: boolean;
    allowAnonDownload?: boolean;
    sortOrder?: number;
    fileSize?: number;
    version?: number;
    isAvailableOffline?: boolean;
    portal?: Portal | undefined;
    siteRoles?: SiteRole[];
}

export interface Permission {
    permissionId?: number;
    registrationId?: number;
    trainingProgramId?: number | undefined;
    permissionType?: PermissionType | undefined;
    registration?: Registration | undefined;
    trainingProgram?: TrainingProgram | undefined;
}

export interface Video {
    videoId?: number;
    fileName?: string;
    label?: string;
    streamPath?: string;
    isFullVideo?: boolean | undefined;
    captionsUrlEn?: string | undefined;
    captionsUrlEs?: string | undefined;
    trainingModuleReviewVideos?: TrainingModule[];
    trainingModuleVideos?: TrainingModule[];
}

export interface Question {
    questionId?: number;
    testId?: number;
    text?: string;
    explanation?: string;
    test?: Test | undefined;
    answers?: Answer[];
    selections?: Selection[] | undefined;
}

export interface Answer {
    answerId?: number;
    questionId?: number;
    text?: string;
    isCorrect?: boolean;
    question?: Question | undefined;
    selections?: Selection[];
}

export interface Selection {
    selectionId?: number;
    resultId?: number;
    questionId?: number;
    answerId?: number;
    score?: number;
    questionCopy?: string;
    answerCopy?: string;
    answer?: Answer | undefined;
    question?: Question | undefined;
    result?: Result | undefined;
}

export interface StaffNotification {
    staffNotificationId?: number;
    timeStamp?: Date;
    title?: string;
    description?: string | undefined;
    timeResolved?: Date | undefined;
    resolvedByPersonId?: number | undefined;
    resolvedComment?: string | undefined;
    resolvedByPerson?: Person | undefined;
}

export interface UserUserCollection {
    id?: number;
    personId?: number;
    userCollectionId?: number;
    person?: Person | undefined;
    userCollection?: UserCollection | undefined;
}

export interface UserCollection {
    id?: number;
    portalId?: number;
    name?: string;
    isStaff?: boolean;
    portal?: Portal | undefined;
}

export interface PushSubscription {
    pushSubscriptionId?: number;
    personId?: number;
    userAgent?: string | undefined;
    token?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    lastSentDate?: Date | undefined;
    lastSeenDate?: Date | undefined;
    person?: Person | undefined;
}

export interface Content {
    contentId?: number;
    portalId?: number;
    contentType?: ContentType;
    isStoredExternally?: boolean;
    contentValue?: string;
    mimeType?: string;
    portal?: Portal | undefined;
}

export enum ContentType {
    None = 0,
    Logo = 1,
    HomePageHeader = 2,
    HomePageParagraph = 3,
    TrainingCompleteMessage = 6,
    Certificate = 10,
    VRHeader = 11,
    RespondHeader = 12,
    TrainingDescription = 10000001,
}

export interface Template {
    templateId?: number;
    portalId?: number;
    name?: string;
    templateText?: string;
    templateType?: string;
    portal?: Portal | undefined;
}

export interface Link {
    linkId?: number;
    portalId?: number;
    linkSectionId?: number;
    label?: string;
    linkUrl?: string;
    sortOrder?: number;
    isKnownGood?: boolean;
    isWarningSuppressed?: boolean;
    portal?: Portal;
    linkSection?: LinkSection | undefined;
}

export interface LinkSection {
    id?: number;
    portalId?: number;
    subheading?: string | undefined;
    portal?: Portal | undefined;
    links?: Link[];
    sortOrder?: number;
}

export interface Setting {
    settingId?: number;
    settingName?: string | undefined;
    settingValue?: string | undefined;
    settingType?: SettingType;
    portals?: Portal[];
}

export enum SettingType {
    ExpiredTrainingEmail = 1,
}

export interface PortalTrainingProgramDTO {
    trainingProgramId?: number;
    name?: string;
}

export interface TenantDTO {
    tenantId?: number;
    propertyId?: number | undefined;
    name?: string | undefined;
    systemName?: string | undefined;
    vrLaunchUrl?: string | undefined;
    ssoMatchValues?: string | undefined;
    isSsoDefault?: boolean | undefined;
    isRestricted?: boolean | undefined;
    sortOrder?: number;
    emailDomainMatch?: string | undefined;
    isEmailVerificationRequired?: boolean;
}

export interface ResponseTypeDTO {
    responseTypeId?: number;
    name?: string | undefined;
    systemName?: string | undefined;
    sortOrder?: number | undefined;
}

export interface PersonPortalDTO {
    firstName?: string;
    lastName?: string | undefined;
    primaryPhone?: string | undefined;
    mobilePhone?: string | undefined;
    contactEmail?: string | undefined;
    roleName?: string | undefined;
}

export interface UserCollectionDTO {
    userCollectionId?: number;
    portalId?: number;
    userCollectionName?: string | undefined;
    isStaff?: boolean;
}

export interface PortalContentDTO {
    contentId?: number;
    contentType?: ContentType;
    isStoredExternally?: boolean;
    contentValue?: string;
    mimeType?: string;
}

export interface SavePortalCommand {
    portalId?: number;
    propertyId?: number;
    clientId?: number;
    portalResponseLibId?: number | undefined;
    portalSiteCode?: string;
    portalSiteCodeAlias?: string | undefined;
    propertyName?: string;
    propertyCategory?: string | undefined;
    propertyPropertyType?: number;
    propertyFloorList?: string | undefined;
    propertyDefaultFloor?: string | undefined;
    domainWhiteList?: string | undefined;
    propertyTenantAlias?: string | undefined;
    portalRespondAnonView?: boolean | undefined;
    portalIsTrainingEnabled?: boolean | undefined;
    portalShowExitButtonAtEndOfModule?: boolean | undefined;
    portalShowFinishButtonAtEndOfQuiz?: boolean | undefined;
    portalIsRespondEnabled?: boolean | undefined;
    portalIsStaffDirEnabled?: boolean | undefined;
    portalIsAlertEnabled?: boolean | undefined;
    portalIsMobilityCheckEnabled?: boolean | undefined;
    portalIsVrtourEnabled?: boolean | undefined;
    portalIsSharedPasswordMode?: boolean | undefined;
    portalIsSSOEnabled?: boolean | undefined;
    portalIsAzureAdEnabled?: boolean | undefined;
    portalIsSSORegistrationEnabled?: boolean | undefined;
    portalIsPasswordLoginEnabled?: boolean | undefined;
    portalSSOButtonLabel?: string | undefined;
    portalSSOLoginUrl?: string | undefined;
    portalSSOCert?: string | undefined;
    portalTenantMapParam?: string | undefined;
    inviteCodeFieldsHidden?: boolean;
    portalIsExpirationEmailsEnabled?: boolean;
    emailTemplateSettingId?: number | undefined;
    portalIsMultiAlertEnabled?: boolean;
    portalIsPushNotificationsEnabled?: boolean | undefined;
    portalHideAllAnonymousContent?: boolean;
    isActive?: boolean;
    portalAlertOriginationNumber?: string | undefined;
}

export interface SaveClientCommand {
    clientId?: number | undefined;
    name?: string;
    expireAfterMonths?: number;
    minimumScorePasses?: number;
    categoryAlias?: string;
    categoryValues?: string;
    note?: string | undefined;
    enableBuildingPickerForAllUsers?: boolean;
    systemName?: string;
}

export interface RolesVm {
    roleTypes?: RoleTypeDTO[] | undefined;
}

export interface RoleTypeDTO {
    roleTypeId?: number;
    name?: string;
    systemName?: string | undefined;
    isStaffRole?: boolean | undefined;
    isPinned?: boolean;
}

export interface SaveRoleTypeCommand {
    roleTypeId?: number | undefined;
    name?: string;
    systemName?: string | undefined;
    isStaffRole?: boolean | undefined;
    isPinned?: boolean | undefined;
}

export interface GetVideoDTO {
    videoId?: number;
    fileName?: string;
    label?: string;
    streamPath?: string;
    isFullVideo?: boolean | undefined;
    captionsUrlEn?: string | undefined;
    captionsUrlEs?: string | undefined;
    portalIds?: number[] | undefined;
}

export interface VideoListItemDTO {
    videoId?: number;
    fileName?: string;
    label?: string;
}

export interface SaveVideoRequest {
    videoId?: number;
    fileName?: string;
    label?: string;
    streamPath?: string;
    isFullVideo?: boolean | undefined;
    captionsUrlEn?: string | undefined;
    captionsUrlEs?: string | undefined;
}

export interface SetNewPasswordDTO {
    email?: string;
    newPassword?: string;
}

export interface WarningLinkDTO {
    linkId?: number;
    portalId?: number;
    linkSectionId?: number;
    label?: string;
    linkUrl?: string;
    isKnownGood?: boolean;
    isWarningSuppressed?: boolean;
    sortOrder?: number;
    linkSectionSubheading?: string;
    linkSectionSortOrder?: number;
    portalName?: string;
}

export interface GetStaffNotificationsVm {
    staffNotifications?: StaffNotificationDTO[];
    totalPages?: number;
    totalUnresolvedCount?: number;
}

export interface StaffNotificationDTO {
    staffNotificationId?: number;
    timeStamp?: Date;
    title?: string;
    description?: string | undefined;
    timeResolved?: Date | undefined;
    resolvedByPersonId?: number | undefined;
    resolvedComment?: string | undefined;
    resolvedByPersonFirstName?: string | undefined;
    resolvedByPersonLastName?: string | undefined;
    resolvedByPersonLoginEmail?: string | undefined;
}

export interface GetStaffNotificationsRequest {
    pageNumber?: number;
    searchString?: string;
}

export interface SaveStaffNotificationRequest {
    staffNotificationId?: number;
    timeStamp?: Date;
    title?: string;
    description?: string | undefined;
    timeResolved?: Date | undefined;
    resolvedByPersonId?: number | undefined;
    resolvedComment?: string | undefined;
}

export interface ResolveStaffNotificationsRequest {
    staffNotificationIds?: number[];
    resolvedByPersonId?: number;
    resolvedComment?: string | undefined;
}

export interface CountsDTO {
    linkWarningsCount?: number;
    urlWarningsCount?: number;
    linkWarningsPortalCount?: number;
    staffNotificationsCount?: number;
}

export interface StaffNoteDTO {
    page?: string;
    note?: string;
}

export interface SaveStaffNoteRequest {
    page?: string;
    note?: string;
}

export interface AdminNoteDTO {
    page?: string;
    note?: string;
    isForTenantAdmin?: boolean;
}

export interface SaveAdminNoteRequest {
    page?: string;
    note?: string;
    isForTenantAdmin?: boolean;
}

export interface MovePortalToClientRequest {
    portalId?: number;
    clientId?: number;
}

export interface BulkAddTrainingRequest {
    portalId?: number;
    trainingProgramID?: number;
}

export interface AdminStartupData {
    originationNumbers?: OriginationNumber[] | undefined;
}

export interface OriginationNumber {
    displayText?: string | undefined;
    service?: string | undefined;
    name?: string | undefined;
    type?: string | undefined;
    originationIdentity?: string | undefined;
}

export interface SaveEmailTemplate {
    settingId?: number | undefined;
    settingName?: string | undefined;
    settingValue?: string | undefined;
    settingType?: SettingType;
}

export interface AlertPersonDTO {
    personId?: number;
    firstName?: string;
    lastName?: string;
    loginEmail?: string;
    roleAlias?: string;
    alertSubscribedFloors?: string;
    contactSms?: string;
    isSmsOptedOut?: boolean;
    contactEmail?: string;
    pushSubscriptionCount?: number;
}

export interface TemplateDTO {
    templateId?: number;
    name?: string;
    template?: string;
    templateType?: string;
}

export interface AlertHistoryDTO {
    alertHistoryId?: number;
    senderPersonId?: number;
    dateSent?: Date;
    smsList?: string | undefined;
    emailList?: string | undefined;
    messageText?: string | undefined;
    messageLog?: string | undefined;
    senderPersonLoginEmail?: string | undefined;
    senderPersonFirstName?: string | undefined;
    senderPersonLastName?: string | undefined;
}

export interface AlertHistoryAllDTO {
    alertHistoryId?: number;
    portalId?: number;
    senderPersonId?: number;
    dateSent?: Date;
    smsList?: string | undefined;
    emailList?: string | undefined;
    messageText?: string | undefined;
    messageLog?: string | undefined;
    senderPersonLoginEmail?: string | undefined;
    senderPersonFirstName?: string | undefined;
    senderPersonLastName?: string | undefined;
    portalPropertyName?: string | undefined;
    portalSiteCode?: string | undefined;
    clientName?: string | undefined;
    recipientCount?: number;
    emailCount?: number;
    smsCount?: number;
    pushCount?: number;
    peopleCount?: number;
}

export interface AlertHistoryDTO2 {
    alertHistoryId?: number;
    portalId?: number;
    senderPersonId?: number;
    dateSent?: Date;
    smsList?: string | undefined;
    emailList?: string | undefined;
    messageText?: string | undefined;
    messageLog?: string | undefined;
    messageError?: string | undefined;
    dateUpdated?: Date | undefined;
    filter?: string | undefined;
    details?: AlertHistoryDetailsDTO[];
}

export interface AlertHistoryDetailsDTO {
    alertHistoryDetailsId?: number;
    timeStamp?: Date;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    eventType?: string | undefined;
    fullDetails?: string | undefined;
    pushToken?: string | undefined;
    callbackDetails?: string | undefined;
    callbackSuccess?: boolean | undefined;
    personId?: number | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userAgent?: string | undefined;
}

export interface AlertHistoryEventDTO {
    alertHistoryDetailsId?: number;
    timeStamp?: Date;
    emailAddress?: string | undefined;
    smsNumber?: string | undefined;
    eventType?: string | undefined;
    fullDetails?: string | undefined;
}

export interface FilteredAlertRecipientsCountRequest {
    portalIds?: number[];
    floors?: string[] | undefined;
    staffRoles?: number[] | undefined;
    nonStaffRoles?: number[] | undefined;
    tenants?: number[] | undefined;
    staffCollections?: number[] | undefined;
    nonStaffCollections?: number[] | undefined;
    allTenants?: boolean;
    allStaff?: boolean;
}

export interface AlertFilterDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    loginEmail?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    isSmsOptedOut?: boolean;
    alertSubscribedFloors?: string | undefined;
    roleAlias?: string | undefined;
    roleId?: number;
    tenantName?: string | undefined;
    tenantId?: number | undefined;
    buildingNames?: string;
    pushSubscriptionCount?: number;
}

export interface FilteredAlertRecipientsRequest {
    portalIds?: number[];
    floors?: string[] | undefined;
    staffRoles?: number[] | undefined;
    nonStaffRoles?: number[] | undefined;
    tenants?: number[] | undefined;
    staffCollections?: number[] | undefined;
    nonStaffCollections?: number[] | undefined;
    allTenants?: boolean;
    allStaff?: boolean;
}

export interface SaveTemplateRequest {
    templateId?: number;
    portalId?: number;
    name?: string;
    text?: string;
    type?: string;
}

export interface SendAlertRequest {
    portalIds?: number[];
    portalName?: string | undefined;
    siteCode?: string | undefined;
    floors?: string[] | undefined;
    staffRoles?: number[] | undefined;
    nonStaffRoles?: number[] | undefined;
    tenants?: number[] | undefined;
    staffCollections?: number[] | undefined;
    nonStaffCollections?: number[] | undefined;
    allTenants?: boolean;
    allStaff?: boolean;
    additionalPhoneNumbers?: string[] | undefined;
    message?: string | undefined;
    smsOriginationNumber?: string | undefined;
}

export interface AlertCounts {
    counts?: number[] | undefined;
    smsSpendThisMonth?: string | undefined;
}

export interface PushSubscriptionDTO {
    pushSubscriptionId?: number;
    userAgent?: string | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    lastSentDate?: Date | undefined;
}

export interface PushTestRequest {
    pushSubscriptionId?: number;
    title?: string;
    body?: string;
    linkUrl?: string | undefined;
    dryRun?: boolean;
}

export interface LinkSectionDTO {
    id?: number;
    subheading?: string | undefined;
    linkSectionSortOrder?: number;
    links?: LinkDTO[];
}

export interface LinkDTO {
    linkId?: number;
    label?: string;
    linkUrl?: string;
    linkSortOrder?: number;
    isKnownGood?: boolean;
    isWarningSuppressed?: boolean;
}

export interface SearchLinkDTO {
    linkId?: number;
    portalId?: number;
    linkSectionId?: number;
    label?: string;
    linkUrl?: string;
    isKnownGood?: boolean;
    isWarningSuppressed?: boolean;
    sortOrder?: number;
    linkSectionSubheading?: string;
    linkSectionSortOrder?: number;
    portalName?: string;
}

export interface SaveLink {
    linkId?: number | undefined;
    portalId?: number;
    linkSectionId?: number;
    label?: string;
    linkUrl?: string;
    isWarningSuppressed?: boolean;
    sortOrder?: number;
}

export interface SaveLinkSection {
    id?: number | undefined;
    portalId?: number;
    subheading?: string;
    sortOrder?: number;
}

export interface SaveLinkSectionOrderRequest {
    linkSectionsOrders?: LinkSectionOrders[] | undefined;
}

export interface LinkSectionOrders {
    linkSectionID?: number;
    linkSectionSortID?: number;
    orderedLinks?: LinkOrders[] | undefined;
}

export interface LinkOrders {
    linkID?: number;
    linkSortID?: number;
}

export interface ImportLinksFromPortalRequest {
    sourcePortalId?: number;
    destinationPortalId?: number;
    sortOrder?: number;
}

export interface PortalMetricsVM {
    portals?: string[] | undefined;
}

export interface TopPortalsVM {
    topByAlertSends?: PortalMetricDTO[];
    topByAlertRecipients?: PortalMetricDTO[];
    topByLogins?: PortalMetricDTO[];
    topByTrainingCompletions?: PortalMetricDTO[];
    topByRegistrations?: PortalMetricDTO[];
    topByAccomplishments?: PortalMetricDTO[];
}

export interface PortalMetricDTO {
    portalId?: number;
    portalName?: string;
    siteCode?: string;
    count?: number;
}

export interface PersonSearchVm {
    people?: PersonSearchDTO[];
}

export interface PersonSearchDTO {
    personId?: number;
    registrationId?: number;
    tenantId?: number;
    siteRoleId?: number;
    firstName?: string | undefined;
    loginEmail?: string | undefined;
    lastName?: string | undefined;
    dateDisabled?: Date | undefined;
    isStaff?: boolean;
    permissions?: PermissionDTO[] | undefined;
    userCollections?: number[];
}

export interface PermissionDTO {
    permissionId?: number;
    registrationId?: number;
    trainingProgramId?: number | undefined;
    permissionType?: PermissionType | undefined;
}

export interface PersonVm {
    person?: PersonDTO | undefined;
}

export interface PersonDTO {
    personId?: number;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    isTenantContact?: boolean;
    isVrAdmin?: boolean;
    isOldVrAdmin?: boolean;
    isMigrated?: boolean;
    isEmailVerified?: boolean;
    dateDisabled?: Date | undefined;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedAlertContactsDate?: Date | undefined;
    registrations?: RegistrationDTO[];
    results?: ResultsDTO[];
    loginHistories?: LoginHistoryDTO[];
}

export interface RegistrationDTO {
    portalId?: number;
    dateRegistered?: Date;
    tenantId?: number;
    siteRoleId?: number;
    isHomePortal?: boolean;
    isVisibleStaffDirectory?: boolean;
    isTenantAdmin?: boolean;
    permissions?: PermissionDTO[] | undefined;
}

export interface ResultsDTO {
    resultId?: number;
    testId?: number;
    trainingModuleId?: number;
    trainingModuleName?: string;
    trainingModuleTrainingProgramName?: string;
    isPassingScore?: boolean | undefined;
    dateStarted?: Date;
    dateCompleted?: Date | undefined;
    isExpired?: boolean | undefined;
}

export interface LoginHistoryDTO {
    loginTime?: Date;
}

export interface TenantAdminSavePersonCommand {
    personId?: number;
    portalId?: number;
    userId?: string | undefined;
    isHomePortal?: boolean;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    siteRoleId?: number | undefined;
    trainingProgramIDs?: number[];
    isTenantContact?: boolean;
    dateDisabled?: Date | undefined;
}

export interface ClientAdminSavePersonCommand {
    personId?: number;
    portalId?: number;
    userId?: string | undefined;
    isHomePortal?: boolean;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    tenantId?: number | undefined;
    siteRoleId?: number | undefined;
    trainingProgramIDs?: number[];
    permissionTypeIDs?: number[];
    isTenantContact?: boolean;
    isVrAdmin?: boolean;
    isOldVrAdmin?: boolean;
    isVisibleStaffDirectory?: boolean | undefined;
    dateDisabled?: Date | undefined;
}

export interface StaffSavePersonCommand {
    personId?: number;
    portalId?: number;
    userId?: string | undefined;
    isHomePortal?: boolean;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    tenantId?: number | undefined;
    siteRoleId?: number | undefined;
    trainingProgramIDs?: number[];
    permissionTypeIDs?: number[];
    isTenantContact?: boolean;
    isTenantAdmin?: boolean;
    isVrAdmin?: boolean;
    isOldVrAdmin?: boolean;
    isVisibleStaffDirectory?: boolean | undefined;
    dateDisabled?: Date | undefined;
}

export interface SelfSavePersonCommand {
    personId?: number;
    portalId?: number;
    userId?: string | undefined;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    tenantId?: number | undefined;
    siteRoleId?: number | undefined;
    trainingProgramIDs?: number[];
}

export interface PeopleSearchDTO {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loginEmail?: string | undefined;
    primaryPhone?: string | undefined;
    mobilePhone?: string | undefined;
    primaryFloor?: string | undefined;
    tenant?: string | undefined;
    roleAlias?: string | undefined;
    dateDisabled?: Date | undefined;
}

export interface GlobalPeopleSearchDTO {
    personId?: number;
    portalId?: number;
    siteCode?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loginEmail?: string | undefined;
}

export interface BulkAddPermissionsRequest {
    personId?: number;
    clientId?: number;
    clientCategory?: string | undefined;
    permissions?: number[];
}

export interface SetPortalPermissionsRequest {
    personId?: number;
    portalId?: number;
    permissions?: number[];
}

export interface PortalSearchVm {
    portals?: PortalSearchDTO[] | undefined;
}

export interface PortalSearchDTO {
    propertyId?: number;
    name?: string;
    category?: string;
    propertyType?: PropertyType;
    systemName?: string;
    portalId?: number;
    siteCode?: string;
    siteCodeAlias?: string | undefined;
    clientId?: number;
    clientName?: string;
    isActive?: boolean;
}

export interface PortalListDTO {
    propertyId?: number;
    name?: string;
    category?: string | undefined;
    clientId?: number;
    propertyType?: PropertyType;
    systemName?: string;
    portalId?: number;
    siteCode?: string;
    siteCodeAlias?: string | undefined;
    clientName?: string;
}

export interface InviteCodesVm {
    inviteCodes?: InviteCodeDTO[];
}

export interface InviteCodeDTO {
    inviteCodeId?: number;
    code?: string;
    portalId?: number;
    enableStaffRoles?: boolean | undefined;
    autoActivateSSO?: boolean | undefined;
    autoActivateV4Upgrade?: boolean | undefined;
    autoActivateForVerifiedEmails?: boolean | undefined;
    dateCreated?: Date;
    dateExpired?: Date | undefined;
    isExpired?: boolean;
    activatedTenantId?: number | undefined;
    trainingProgramIds?: number[] | undefined;
    permissionTypes?: PermissionType[] | undefined;
}

export interface SaveNumberCommand {
    numberId?: number;
    portalId?: number;
    label?: string | undefined;
    subLabel?: string | undefined;
    emergencyNumber?: string | undefined;
    allowAnonView?: boolean;
    sortOrder?: number | undefined;
    siteRoleIDs?: number[];
}

export interface DisableTenantUsersCommand {
    tenantId?: number;
    portalId?: number;
}

export interface SaveTenantCommand {
    tenantId?: number;
    propertyId?: number;
    portalId?: number;
    name?: string;
    systemName?: string;
    vrLaunchUrl?: string;
    ssoMatchValues?: string;
    isSsoDefault?: boolean;
    isRestricted?: boolean;
    sortOrder?: number;
    emailDomainMatch?: string;
    isEmailVerificationRequired?: boolean;
}

export interface SaveTenantOrderRequest {
    tenantOrders?: TenantOrders[] | undefined;
    portalId?: number;
}

export interface TenantOrders {
    tenantId?: number;
    sortOrder?: number;
}

export interface BulkTenantRequest {
    propertyId?: number;
    bulkTenantList?: string;
}

export interface DeleteNumberCommand {
    numberId?: number;
    portalId?: number;
}

export interface SaveNumberOrderRequest {
    numberOrders?: NumberOrders[] | undefined;
    portalId?: number;
}

export interface NumberOrders {
    numberId?: number;
    sortOrder?: number;
}

export interface SaveDocumentCommand {
    documentId?: number;
    portalId?: number;
    label?: string;
    fileName?: string | undefined;
    mimeType?: string;
    allowAnonLinkView?: boolean;
    allowAnonDownload?: boolean;
    sortOrder?: number | undefined;
    fileSize?: number | undefined;
    isAvailableOffline?: boolean | undefined;
    siteRoleIDs?: number[];
}

export interface SaveDocumentOrderRequest {
    documentOrders?: DocumentOrders[] | undefined;
    portalId?: number;
}

export interface DocumentOrders {
    documentId?: number;
    sortOrder?: number;
}

export interface SaveInviteCodeCommand {
    inviteCodeId?: number;
    code?: string;
    portalId?: number;
    enableStaffRoles?: boolean | undefined;
    autoActivateSSO?: boolean | undefined;
    autoActivateV4Upgrade?: boolean | undefined;
    autoActivateForVerifiedEmails?: boolean | undefined;
    dateExpired?: Date | undefined;
    trainingProgramIds?: number[] | undefined;
    permissionTypes?: PermissionType[] | undefined;
    activatedTenantId?: number | undefined;
}

export interface SaveSiteRoleCommand {
    siteRoleId?: number;
    portalId?: number;
    roleTypeId?: number;
    roleAlias?: string | undefined;
    systemName?: string | undefined;
    sortOrder?: number | undefined;
    isStaffRole?: boolean;
}

export interface SaveSiteRoleOrderRequest {
    siteRoleOrders?: SiteRoleOrders[] | undefined;
}

export interface SiteRoleOrders {
    siteRoleId?: number;
    sortOrder?: number;
}

export interface SaveContentRequest {
    contentId?: number;
    portalId?: number;
    contentType?: ContentType;
    isStoredExternally?: boolean;
    contentValue?: string;
    mimeType?: string;
}

export interface ContentDTO {
    contentId?: number;
    portalId?: number;
    contentType?: number;
    isStoredExternally?: boolean;
    contentValue?: string;
    mimeType?: string;
}

export interface SaveUserCollectionRequest {
    userCollectionId?: number | undefined;
    userCollectionName?: string | undefined;
    portalId?: number;
    isStaff?: boolean | undefined;
    users?: number[] | undefined;
}

export interface DeleteUserCollectionRequest {
    userCollectionId?: number;
    portalId?: number;
}

export interface TrainingResultVm {
    results?: TrainingResultDTO[];
    userCounts?: { [key: string]: number; };
}

export interface TrainingResultDTO {
    personId?: number;
    dateCompleted?: Date | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    roleName?: string | undefined;
    siteRoleId?: number | undefined;
    tenantName?: string | undefined;
    floor?: string | undefined;
    moduleName?: string | undefined;
    trainingProgramName?: string | undefined;
    passed?: boolean | undefined;
    testName?: string | undefined;
    correctAnswerCount?: number;
    answerCount?: number;
}

export interface RosterPersonDTO {
    personId?: number;
    registrationId?: number;
    firstName?: string;
    lastName?: string;
    loginEmail?: string;
    tenantName?: string;
    roleAlias?: string;
    primaryFloor?: string;
    primaryPhone?: string;
    isMobilityImpaired?: boolean;
    isTenantContact?: boolean;
}

export interface VRAccomplishmentDTO {
    firstName?: string | undefined;
    lastName?: string | undefined;
    loginEmail?: string | undefined;
    tenant?: string | undefined;
    role?: string | undefined;
    accomplishment?: string | undefined;
    dateAccomplished?: Date | undefined;
}

export interface VRFilterDTO {
    personId?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    loginEmail?: string | undefined;
    tenant?: string | undefined;
    role?: string | undefined;
    accomplishments?: VRFilterDetail[];
    startTourDate?: Date | undefined;
    endTourDate?: Date | undefined;
    missionsStartDate?: Date | undefined;
    missionsEndDate?: Date | undefined;
}

export interface VRFilterDetail {
    accomplishmentName?: string;
    dateAccomplished?: Date;
}

export interface TrainingExpirationPersonDTO {
    personId?: number;
    registrationId?: number;
    firstName?: string;
    lastName?: string;
    loginEmail?: string;
    tenantName?: string;
    roleAlias?: string;
    primaryFloor?: string;
    primaryPhone?: string;
    isMobilityImpaired?: boolean;
    isTenantContact?: boolean;
}

export interface SimpleResponseLibDTO {
    responseLibId?: number;
    name?: string;
}

export interface ResponseLibDTO {
    responseLibId?: number;
    name?: string;
    responseLibItems?: ResponseLibItemDTO[];
}

export interface ResponseLibItemDTO {
    responseLibItemId?: number;
    responseLibId?: number;
    responseTypeId?: number;
    responseTypeName?: string;
    roleTypeId?: number;
    roleName?: string;
    responseText?: string;
}

export interface ResponseTypeDTO2 {
    responseTypeId?: number;
    name?: string;
    systemName?: string | undefined;
}

export interface SaveResponseTypeRequest {
    responseTypeId?: number;
    name?: string;
    systemName?: string | undefined;
}

export interface ResponseDTO {
    responseLibItemId?: number;
    responseTypeId?: number;
    roleTypeId?: number;
    responseId?: number | undefined;
    responseTypeName?: string;
    responseTypeSystemName?: string | undefined;
    siteRoleId?: number;
    roleName?: string;
    responseText?: string | undefined;
    isHidden?: boolean;
}

export interface ExcludedResponseTypeDTO {
    responseTypeId?: number;
}

export interface ResponseVisibilityRequest {
    portalId?: number;
    excludedResponseTypeIds?: number[];
    excludedSiteRoleIds?: number[];
}

export interface SaveResponse {
    responseId?: number | undefined;
    responseLibItemId?: number;
    siteRoleId?: number;
    responseText?: string;
    isHidden?: boolean;
}

export interface SaveResponseLib {
    responseLibId?: number;
    name?: string;
    copySourceId?: number | undefined;
}

export interface SaveResponseLibItem {
    responseLibItemId?: number;
    responseLibId?: number;
    responseTypeId?: number;
    roleTypeId?: number;
    responseText?: string;
}

export interface SearchResponseResultsDTO {
    libItems?: SearchResponseLibItemDTO[];
    overrides?: SearchResponseDTO[];
}

export interface SearchResponseLibItemDTO {
    responseLibItemId?: number;
    responseLibId?: number;
    responseTypeName?: string;
    roleTypeId?: number;
    responseText?: string;
}

export interface SearchResponseDTO {
    responseId?: number;
    responseLibItemId?: number;
    portalId?: number;
    responseTypeName?: string;
    siteRoleName?: string;
    responseText?: string | undefined;
    isHidden?: boolean;
}

export interface SearchAllResponseContentRequest {
    searchText?: string;
    includeOverrides?: boolean;
}

export interface SearchResponseContentByLibraryRequest {
    searchText?: string;
    responseLibId?: number;
}

export interface SearchResponseContentByPortalRequest {
    searchText?: string;
    portalId?: number;
}

export interface ResponseTypeOrderRequest {
    portalId?: number;
    responseTypeOrder?: ResponseTypeOrder[] | undefined;
}

export interface ResponseTypeOrder {
    responseTypeId?: number;
    sortOrder?: number;
}

export interface ResponseScenariosDTO {
    responseLibId?: number;
    name?: string;
    responseLibItems?: ResponseScenarioDTO[];
}

export interface ResponseScenarioDTO {
    responseLibItemId?: number;
    responseTypeId?: number;
    responseTypeName?: string;
    roleTypeId?: number;
    roleName?: string;
}

export interface SimpleTrainingProgramDTO {
    trainingProgramId?: number;
    portalId?: number;
    name?: string;
}

export interface TrainingProgramDTO {
    trainingProgramId?: number;
    portalId?: number;
    name?: string;
    isActive?: boolean;
    v4Password?: string | undefined;
    trainingModules?: TrainingModuleDTO[];
}

export interface TrainingModuleDTO {
    trainingModuleId?: number;
    trainingProgramId?: number;
    name?: string;
    portalId?: number;
    videoId?: number | undefined;
    isActive?: boolean;
    video?: ClientVideoDTO | undefined;
}

export interface ClientVideoDTO {
    videoId?: number;
    label?: string;
    streamPath?: string;
}

export interface SaveTrainingProgram {
    trainingProgramId?: number;
    portalId?: number;
    name?: string;
    v4Password?: string;
    isActive?: boolean | undefined;
}

export interface ImportTrainingProgramsFromPortalRequest {
    destinationPortalId?: number;
    trainingProgramIds?: number[];
}

export interface SaveTrainingModule {
    trainingModuleId?: number;
    trainingProgramId?: number;
    portalId?: number;
    videoId?: number | undefined;
    name?: string;
    isActive?: boolean | undefined;
}

export interface TestDTO {
    testId?: number;
    moduleId?: number;
    title?: string;
    isActive?: boolean;
    dateExpired?: Date | undefined;
}

export interface Request {
    testId?: number;
    moduleId?: number;
    title?: string;
    isActive?: boolean | undefined;
}

export interface QuestionDTO {
    questionId?: number;
    testId?: number;
    text?: string;
    explanation?: string;
    answers?: AnswerDTO[] | undefined;
}

export interface AnswerDTO {
    answerId?: number;
    questionId?: number;
    text?: string;
    isCorrect?: boolean;
}

export interface Request2 {
    questionId?: number;
    testId?: number;
    text?: string;
    explanation?: string;
}

export interface Request3 {
    questionId?: number;
    answerId?: number;
    text?: string;
    isCorrect?: boolean;
}

export interface Request4 {
    personId?: number;
    testId?: number;
    trainingModuleId?: number;
    clientId?: number;
    selections?: SaveResultSelectionDTO[];
}

export interface SaveResultSelectionDTO {
    questionId?: number;
    answerId?: number;
    score?: number;
    questionCopy?: string;
    answerCopy?: string;
}

export interface BulkRemoveTrainingProgramPermissionRequest {
    portalId?: number;
    trainingProgramId?: number;
}

export interface BulkAddTrainingProgramPermissionRequest {
    portalId?: number;
    trainingProgramId?: number;
}

export interface RegisterRequest {
    inviteCodeIds?: number[] | undefined;
    loginEmail?: string;
    password?: string;
    firstName?: string;
    lastName?: string | undefined;
    siteRoleId?: number | undefined;
    tenantId?: number | undefined;
    isHomePortal?: boolean | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    isPushOptedOut?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    portalId?: number;
    trainingProgramIds?: number[] | undefined;
}

export interface LoginVm {
    person?: LoginPersonDTO | undefined;
    error?: string | undefined;
    upgradePassword?: boolean | undefined;
    siteCode?: string | undefined;
    hasClientAccess?: boolean;
    hasRegionAccess?: boolean;
}

export interface LoginPersonDTO {
    personId?: number;
    loginEmail?: string;
    firstName?: string;
    lastName?: string | undefined;
    primaryFloor?: string | undefined;
    mobilePhone?: string | undefined;
    primaryPhone?: string | undefined;
    contactEmail?: string | undefined;
    contactSms?: string | undefined;
    isSmsOptedOut?: boolean;
    isPushOptedOut?: boolean;
    alertSubscribedFloors?: string | undefined;
    isMobilityImpaired?: boolean | undefined;
    grantedAccessToRegion?: string | undefined;
    grantedAccessToClient?: boolean | undefined;
    isTenantAdmin?: boolean;
    isTenantContact?: boolean;
    isVrAdmin?: boolean;
    isOldVrAdmin?: boolean;
    tenantName?: string | undefined;
    tenantSystemName?: string | undefined;
    isEmailVerificationRequired?: boolean;
    createdDate?: Date;
    updatedDate?: Date | undefined;
    updatedAlertContactsDate?: Date | undefined;
    results?: ResultsDTO[];
    allRegistrations?: LoginRegistrationDTO[];
    portalId?: number | undefined;
    tenantId?: number | undefined;
    siteRoleId?: number | undefined;
    isComplete?: boolean | undefined;
    dateRegistered?: Date | undefined;
    isStaffRole?: boolean | undefined;
    permissions?: PermissionDTO2[];
    token?: string | undefined;
    isEmailVerified?: boolean;
}

export interface LoginRegistrationDTO {
    siteCode?: string;
    propertyName?: string;
    clientName?: string;
    tenantName?: string;
}

export interface PermissionDTO2 {
    permissionId?: number;
    registrationId?: number;
    trainingProgramId?: number;
    permissionType?: PermissionType | undefined;
}

export interface LoginRequest {
    userName?: string | undefined;
    password?: string | undefined;
    portalId?: number | undefined;
    clientSystemName?: string | undefined;
    regionName?: string | undefined;
}

export interface ImpersonateRequest {
    userName?: string | undefined;
    portalId?: number | undefined;
    clientSystemName?: string | undefined;
    regionName?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}

// The body of the class will be copied into generated calss